import { useState, useEffect, useRef } from "react";
import QRCode from "qrcode";
import { ChevronDown, ChevronRight, X, LogOut, User, Clock, FileText, Bitcoin, Copy, Check, Menu, ArrowLeft, PawPrint, Upload, Mail, LandmarkIcon, Download } from "lucide-react";

// ─── CONFIG ───────────────────────────────────────────────────────────────────
const API = "https://pawmarket-backend-production-92f7.up.railway.app/api";
// Live rate stored at module level, refreshed every 5 minutes
let LIVE_BTC_RATE = 73123; // fallback until first fetch

async function fetchBTCRate() {
  try {
    const res  = await fetch("https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd");
    const data = await res.json();
    LIVE_BTC_RATE = data.bitcoin.usd;
  } catch(e) {
    console.warn("BTC rate fetch failed, using last known rate");
  }
}

// Fetch immediately and then every 5 minutes
fetchBTCRate();
setInterval(fetchBTCRate, 5 * 60 * 1000);

function toUSD(btcVal) {
  const n = parseFloat(btcVal);
  return "$" + (n * LIVE_BTC_RATE).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}

// ─── EMOJI MAP ────────────────────────────────────────────────────────────────
const EMOJI_MAP = { dog: "🏛️", cat: "🏛️", bird: "🏛️", fish: "🏛️", reptile: "🏛️" };


const STORE_ANIMALS = {
  dog: [
    { id:"ck1", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-03-1997 GENDER: FEMALE", price_btc:0.00402326, stock:3520.00 },
    { id:"hc1", pet:"Wood forest Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-06-1961 GENDER: FEMALE", price_btc:0.00385056, stock:3380.00 },
    { id:"lr1", pet:"Wells Fargo & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-08-1967 GENDER: MALE", price_btc:0.00389084, stock:3412.65 },
    { id:"hm1", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-07-1987 GENDER: MALE", price_btc:0.00388757, stock:3410.00 },
    { id:"ax1", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-09-2002 GENDER: MALE", price_btc:0.00403624, stock:3530.52 },
    { id:"rb1", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-05-1961 GENDER: FEMALE", price_btc:0.00397392, stock:3480.00 },
    { id:"cs1", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-04-1977 GENDER: MALE", price_btc:0.00408494, stock:3570.00 },
    { id:"lg1", pet:"TD Group US Holdings LLC", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-03-1954 GENDER: MALEt", price_btc:0.00413428, stock:3610.00 },
    { id:"gf1", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-08-1966 GENDER: FEMALE", price_btc:0.00402326, stock:3520.00 },
    { id:"fb1", pet:"JPmorgan Chase & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-10-1958 GENDER: MALE", price_btc:0.00748893, stock:6329.53 },
    { id:"ig1", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-09-1982 GENDER: MALE", price_btc:0.00410961, stock:3590.00 },
    { id:"lb1", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-11-1977 GENDER: MALE", price_btc:0.00399859, stock:3500.00 },
    { id:"ko1", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-12-1989 GENDER: MALE", price_btc:0.00412194, stock:3600.00 },
    { id:"fe1", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-2004 GENDER: FEMALE", price_btc:0.00375272, stock:3300.68 },
    { id:"hh1", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-03-1985 GENDER: MALE", price_btc:0.00362944, stock:3200.74 },
    { id:"sg1", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-04-1980 GENDER: MALE", price_btc:0.00417135, stock:3640.05 },
    { id:"gr1", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 08-03-1952 GENDER: MALE", price_btc:0.00418931, stock:3654.61 },
    { id:"cn1", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-04-1963 GENDER: FEMALE", price_btc:0.00394925, stock:3460.00 },
    { id:"vc1", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-09-1994 GENDER: FEMALE", price_btc:0.00404793, stock:3540.00 },
    { id:"gs1", pet:"Bank Of America Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-08-1983 GENDER: MALE", price_btc:0.00389004, stock:3412.00 },
    { id:"ko1", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-11-1982 GENDER: FEMALEe", price_btc:0.00412194, stock:3600.00 },
    { id:"ta1", pet:"PNC Financial Services Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-11-1955 GENDER: MALE", price_btc:0.00356172, stock:3145.84 },
    { id:"gb1", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1972 GENDER: FEMALE", price_btc:0.00391224, stock:3430.00 },
    { id:"ch1", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-07-1958 GENDER: FEMALE", price_btc:0.00981863, stock:8218.16 }
  ],
  cat: [
    { id:"cnr1", pet:"Coventry Building Society", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-2003 GENDER: FEMALE", price_btc:0.00398625, stock:3490.00 },
    { id:"bg1", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-09-1982 GENDER: MALE", price_btc:0.00404793, stock:3540.00 },
    { id:"sx1", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-09-1961 GENDER: FEMALE", price_btc:0.00413428, stock:3610.00 },
    { id:"p1", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-07-1981 GENDER: MALE", price_btc:0.00389004, stock:3412.00 },
    { id:"be1", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-06-1967 GENDER: FEMALE", price_btc:0.00500384, stock:4314.93 },
    { id:"rg1", pet:"Nationwide Building Soc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-02-1982 GENDER: FEMALE", price_btc:0.00402326, stock:3520.00 },
    { id:"si1", pet:"Lloyds Banking Group", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-03-1957 GENDER: MALE", price_btc:0.01168035, stock:9727.41 },
    { id:"csp1", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-07-1984 GENDER: FEMALE", price_btc:0.00393691, stock:3450.00 },
    { id:"po1", pet:"Santander UK", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-05-1984 GENDER: FEMALE", price_btc:0.00396158, stock:3470.00 },
    { id:"mc1", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-10-1969 GENDER: FEMALE", price_btc:0.00428972, stock:3736.01 }
  ],
  bird: [
    { id:"zf1", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-07-2001 GENDER: FEMALE", price_btc:0.00391224, stock:3430.00 },
    { id:"af1", pet:"Canadian Western Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-07-1961 GENDER: FEMALE", price_btc:0.00403559, stock:3530.00 },
    { id:"co1", pet:"Toronto-Dominion Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-03-1953 GENDER: FEMALE", price_btc:0.00459333, stock:3982.14 },
    { id:"ma1", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-1987 GENDER: FEMALE", price_btc:0.00409314, stock:3576.65 },
    { id:"ag1", pet:"Royal Bank of Canada", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-04-2005 GENDER: MALE", price_btc:0.00408522, stock:3570.23 },
    { id:"bu1", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-11-1986 GENDER: MALE", price_btc:0.00583329, stock:4987.35 },
    { id:"gp1", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-07-1988 GENDER: FEMALE", price_btc:0.00399859, stock:3500.00 }
  ],
  fish: [
    { id:"hc1", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-05-1976 GENDER: FEMALE", price_btc:0.00436865, stock:3800.00 },
    { id:"sg1", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-05-2003 GENDER: FEMALE", price_btc:0.00757586, stock:6400.00 },
    { id:"ig1", pet:"Bendigo Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-08-1979 GENDER: FEMALE", price_btc:0.00695909, stock:5900.00 },
    { id:"rs1", pet:"ANZ Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-09-1962 GENDER: FEMALE", price_btc:0.00412194, stock:3600.00 },
    { id:"fe1", pet:"Commonwealth Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-11-1971 GENDER: FEMALE", price_btc:0.00720579, stock:6100.00 },
    { id:"ax1", pet:"Westpac Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-05-1992 GENDER: FEMALE", price_btc:0.00562176, stock:4815.86 },
    { id:"ta1", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-05-1997 GENDER: MALE", price_btc:0.00558269, stock:4784.19 }
  ],
  reptile: [],
};



// ─── HARDCODED VARIATIONS PER ANIMAL ─────────────────────────────────────────
// Each store has variations of that single animal (different styles/editions)
// ─── ANIMAL VARIATIONS ────────────────────────────────────────────────────────
const ANIMAL_VARIATIONS = {
  "S&T Bank": [
    { id:"gr1", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 08-03-1952 GENDER: MALE", price_btc:0.00418931, stock:3654.61 },
    { id:"gr2", pet:"S&T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-10-1991 GENDER: MALE", price_btc:0.00456225, stock:3956.95 },
    { id:"gr3", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 27-08-1961 GENDER: FEMALE", price_btc:0.00569652, stock:4876.47 },
    { id:"gr4", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY + BANK. ACCESS ONLY DOB: 18-08-1994 GENDER: FEMALE", price_btc:0.00566677, stock:4852.35 },
    { id:"gr5", pet:"S&T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK. ACCESS ONLY DOB: 05-01-1950 GENDER: FEMALE", price_btc:0.00401689, stock:3514.84 },
    { id:"gr6", pet:"S&T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK. ACCESS ONLY DOB: 03-05-1995 GENDER: FEMALE", price_btc:0.00410641, stock:3587.41 },
    { id:"gr7", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-04-1984 GENDER: MALE", price_btc:0.00398573, stock:3489.58 },
    { id:"gr8", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-01-1950 GENDER: MALE", price_btc:0.00340000, stock:3014.74 },
    { id:"gr9", pet:"S&T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-01-1952 GENDER: FEMALE", price_btc:0.00455673, stock:3952.47 },
    { id:"gr10", pet:"S&T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-01-1951 GENDER: MALE", price_btc:0.00369545, stock:3254.25 }
  ],
  "JPmorgan Chase & Co.": [
    { id:"fb1", pet:"JPmorgan Chase & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-10-1958 GENDER: MALE", price_btc:0.00748893, stock:6329.53 },
    { id:"fb2", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-08-1993 GENDER: MALE", price_btc:0.00396876, stock:3475.82 },
    { id:"fb3", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-11-2002 GENDER: FEMALE", price_btc:0.00481582, stock:4162.51 },
    { id:"fb4", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-07-1985 GENDER: MALE", price_btc:0.00583180, stock:4986.14 },
    { id:"fb5", pet:"JPmorgan Chase & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-05-1990 GENDER: MALE", price_btc:0.00685310, stock:5814.08 },
    { id:"fb6", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-04-1985 GENDER: MALE", price_btc:0.00804676, stock:6781.75 },
    { id:"fb7", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-02-2003 GENDER: FEMALE", price_btc:0.00933547, stock:7826.47 },
    { id:"fb8", pet:"JPmorgan Chase & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-07-1980 GENDER: FEMALE", price_btc:0.01079447, stock:9009.25 },
    { id:"fb9", pet:"JPmorgan Chase & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-09-1970 GENDER: FEMALE", price_btc:0.00384238, stock:3373.37 },
    { id:"fb10", pet:"JPmorgan Chase & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-03-1966 GENDER: FEMALE", price_btc:0.00360467, stock:3180.66 }
  ],
  "Bank Of America Corp.": [
    { id:"gs1", pet:"Bank Of America Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-08-1983 GENDER: MALE", price_btc:0.00389004, stock:3412.60 },
    { id:"gs2", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-11-1954 GENDER: MALE", price_btc:0.00477214, stock:4127.10 },
    { id:"gs3", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-08-1973 GENDER: FEMALE", price_btc:0.00582832, stock:4983.32 },
    { id:"gs4", pet:"Bank Of America Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-07-1966 GENDER: MALE", price_btc:0.00707556, stock:5994.42 },
    { id:"gs5", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-08-1965 GENDER: FEMALE", price_btc:0.00818471, stock:6893.58 },
    { id:"gs6", pet:"Bank Of America Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-12-1979 GENDER: MALE", price_btc:0.00804601, stock:6781.14 },
    { id:"gs7", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-04-1957 GENDER: MALE", price_btc:0.00933602, stock:7826.92 },
    { id:"gs8", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-07-2004 GENDER: FEMALE", price_btc:0.01091811, stock:9109.48 },
    { id:"gs9", pet:"Bank Of America Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-04-1977 GENDER: MALE", price_btc:0.00371749, stock:3272.12 },
    { id:"gs10", pet:"Bank Of America Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-10-1996 GENDER: MALE", price_btc:0.01199959, stock:9986.21 }
  ],
  "Wells Fargo & Co.": [
    { id:"lr1", pet:"Wells Fargo & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-08-1967 GENDER: MALE", price_btc:0.00389084, stock:3412.65 },
    { id:"lr2", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-12-1989 GENDER: FEMALE", price_btc:0.00477303, stock:4127.82 },
    { id:"lr3", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-02-1986 GENDER: MALE", price_btc:0.00582906, stock:4983.92 },
    { id:"lr4", pet:"Wells Fargo & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-05-1970 GENDER: FEMALE", price_btc:0.00707574, stock:5994.57 },
    { id:"lr5", pet:"Wells Fargo & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-08-1990 GENDER: FEMALE", price_btc:0.00448458, stock:3893.98 },
    { id:"lr6", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-05-2004 GENDER: MALE", price_btc:0.00804639, stock:6781.45 },
    { id:"lr7", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-04-1957 GENDER: MALE", price_btc:0.00933602, stock:7826.92 },
    { id:"lr8", pet:"Wells Fargo & Co.", emoji:"", description:"SAVINGS + CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 26-11-1999 GENDER: FEMALE", price_btc:0.01091770, stock:9109.15 },
    { id:"lr9", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-11-1998 GENDER: FEMALE", price_btc:0.01119181, stock:9331.36 },
    { id:"lr10", pet:"Wells Fargo & Co.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-12-1952 GENDER: MALE", price_btc:0.01200000, stock:9986.54 }
  ],
  "Citi Group Inc.": [
    { id:"ch1", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-07-1958 GENDER: FEMALE", price_btc:0.00981863, stock:8218.16 },
    { id:"ch2", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-01-1975 GENDER: MALE", price_btc:0.00360451, stock:3180.53 },
    { id:"ch3", pet:"Citi Group Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-12-1960 GENDER: FEMALE", price_btc:0.00908168, stock:7620.73 },
    { id:"ch4", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-06-1961 GENDER: MALE", price_btc:0.00424547, stock:3700.14 },
    { id:"ch5", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-05-1995 GENDER: FEMALE", price_btc:0.00634294, stock:5400.51 },
    { id:"ch6", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-05-1955 GENDER: FEMALE", price_btc:0.00771874, stock:6515.83 },
    { id:"ch7", pet:"Citi Group Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-12-1978 GENDER: MALE", price_btc:0.00905641, stock:7600.25 },
    { id:"ch8", pet:"Citi Group Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-03-1976 GENDER: FEMALE", price_btc:0.00555559, stock:4762.22 },
    { id:"ch9", pet:"Citi Group Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-10-1974 GENDER: MALE", price_btc:0.00353064, stock:3120.65 },
    { id:"ch10", pet:"Citi Group Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-03-1977 GENDER: FEMALE", price_btc:0.01103081, stock:9200.84 }
  ],
  "Chime Bank": [
    { id:"hh1", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-03-1985 GENDER: MALE", price_btc:0.00362944, stock:3200.74 },
    { id:"hh2", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-05-1995 GENDER: MALE", price_btc:0.00663140, stock:5634.35 },
    { id:"hh3", pet:"Chime Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 27-07-1991 GENDER: MALE", price_btc:0.00375268, stock:3300.65 },
    { id:"hh4", pet:"Chime Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 23-10-1994 GENDER: FEMALE", price_btc:0.00362867, stock:3200.12 },
    { id:"hh5", pet:"Chime Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY +  BANK ACCESS ONLY DOB: 10-05-1993 GENDER: FEMALE", price_btc:0.00720700, stock:6100.98 },
    { id:"hh6", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-12-1958 GENDER: FEMALE", price_btc:0.00353722, stock:3125.98 },
    { id:"hh7", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-02-1958 GENDER: FEMALE", price_btc:0.01004374, stock:8400.65 },
    { id:"hh8", pet:"Chime Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-12-1992 GENDER: FEMALE", price_btc:0.00662688, stock:5630.69 },
    { id:"hh9", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-08-1953 GENDER: MALE", price_btc:0.00554096, stock:4750.36 },
    { id:"hh10", pet:"Chime Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-06-2001 GENDER: MALE", price_btc:0.01164750, stock:9700.78 }
  ],
  "Huntington National Bank": [
    { id:"fe1", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-2004 GENDER: FEMALE", price_btc:0.00375272, stock:3300.68 },
    { id:"fe2", pet:"Huntington National Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-08-1966 GENDER: FEMALE", price_btc:0.00501033, stock:4320.19 },
    { id:"fe3", pet:"Huntington National Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-08-1954 GENDER: MALE", price_btc:0.00479182, stock:4143.05 },
    { id:"fe4", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-04-1979 GENDER: FEMALE", price_btc:0.00387628, stock:3400.85 },
    { id:"fe5", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-05-1980 GENDER: FEMALE", price_btc:0.00683656, stock:5800.67 },
    { id:"fe6", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-02-1991 GENDER: MALE", price_btc:0.00355509, stock:3140.47 },
    { id:"fe7", pet:"Huntington National Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-12-1980 GENDER: MALE", price_btc:0.00843993, stock:7100.48 },
    { id:"fe8", pet:"Huntington National Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-01-1987 GENDER: MALE", price_btc:0.00566178, stock:4848.31 },
    { id:"fe9", pet:"Huntington National Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-09-1951 GENDER: FEMALE", price_btc:0.00560238, stock:4800.15 }
  ],
  "PNC Financial Services Inc.": [
    { id:"ta1", pet:"PNC Financial Services Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-11-1955 GENDER: MALE", price_btc:0.00356172, stock:3145.84 },
    { id:"ta2", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY +  BANK ACCESS  ONLY DOB: 04-03-1997 GENDER: MALE", price_btc:0.00830858, stock:6994.17 },
    { id:"ta3", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-03-1980 GENDER: FEMALE", price_btc:0.00343132, stock:3040.13 },
    { id:"ta4", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-07-2004 GENDER: MALE", price_btc:0.00434481, stock:3780.67 },
    { id:"ta5", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-11-2004 GENDER: MALE", price_btc:0.00794658, stock:6700.54 },
    { id:"ta6", pet:"PNC Financial Services Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-09-2001 GENDER: MALE", price_btc:0.00382640, stock:3360.41 },
    { id:"ta7", pet:"PNC Financial Services Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-11-1962 GENDER: MALE", price_btc:0.00942739, stock:7900.99 },
    { id:"ta8", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-11-1968 GENDER: FEMALE", price_btc:0.00883679, stock:7422.21 },
    { id:"ta9", pet:"PNC Financial Services Inc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-11-1985 GENDER: MALE", price_btc:0.00498619, stock:4300.62 },
    { id:"ta10", pet:"PNC Financial Services Inc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-07-1976 GENDER: MALE", price_btc:0.01090714, stock:9100.59 }
  ],
  "Truist Financial Corp.": [
    { id:"ax1", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-09-2002 GENDER: MALE", price_btc:0.00403624, stock:3530.52 },
    { id:"ax2", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-12-1959 GENDER: FEMALE", price_btc:0.00950086, stock:7960.55 },
    { id:"ax3", pet:"Truist Financial Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-06-1973 GENDER: FEMALE", price_btc:0.01138033, stock:9484.19 },
    { id:"ax4", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-06-1992 GENDER: FEMALE", price_btc:0.00449209, stock:3900.07 },
    { id:"ax5", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-11-1958 GENDER: FEMALE", price_btc:0.00745302, stock:6300.42 },
    { id:"ax6", pet:"Truist Financial Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-02-1976 GENDER: FEMALE", price_btc:0.00386983, stock:3395.62 },
    { id:"ax7", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-07-1950 GENDER: FEMALE", price_btc:0.00868704, stock:7300.81 },
    { id:"ax8", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-05-1996 GENDER: MALE", price_btc:0.00533527, stock:4583.61 },
    { id:"ax9", pet:"Truist Financial Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-02-1987 GENDER: FEMALE", price_btc:0.00422067, stock:3680.04 },
    { id:"ax10", pet:"Truist Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-08-1968 GENDER: MALE", price_btc:0.01140100, stock:9500.95 }
  ],
  "Truist Bank": [
    { id:"sg1", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-04-1980 GENDER: MALE", price_btc:0.00417135, stock:3640.05 },
    { id:"sg2", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-03-1958 GENDER: MALE", price_btc:0.01069828, stock:8931.27 },
    { id:"sg3", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-10-2000 GENDER: FEMALE", price_btc:0.00905132, stock:7596.12 },
    { id:"sg4", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-03-1965 GENDER: MALE", price_btc:0.00439449, stock:3820.95 },
    { id:"sg5", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-08-1966 GENDER: FEMALE", price_btc:0.00695939, stock:5900.25 },
    { id:"sg6", pet:"Truist Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-07-1998 GENDER: FEMALE", price_btc:0.00391281, stock:3430.46 },
    { id:"sg7", pet:"Truist Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-04-2003 GENDER: FEMALE", price_btc:0.00807035, stock:6800.87 },
    { id:"sg8", pet:"Truist Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-05-1994 GENDER: FEMALE", price_btc:0.01053131, stock:8795.91 },
    { id:"sg9", pet:"Truist Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-06-1955 GENDER: FEMALE", price_btc:0.00449304, stock:3900.84 },
    { id:"sg10", pet:"Truist Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-05-1993 GENDER: MALE", price_btc:0.01028995, stock:8600.25 }
  ],
  "Wood forest Bank": [
    { id:"hc1", pet:"Wood forest Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-06-1961 GENDER: FEMALE", price_btc:0.00385056, stock:3380.02 },
    { id:"hc2", pet:"Wood forest Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-02-1996 GENDER: FEMALE", price_btc:0.00835484, stock:7031.50 },
    { id:"hc3", pet:"Wood forest Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-05-2000 GENDER: MALE", price_btc:0.00364086, stock:3210.54 },
    { id:"hc4", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-03-1974 GENDER: FEMALE", price_btc:0.00431931, stock:3760.78 },
    { id:"hc5", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-01-1978 GENDER: FEMALE", price_btc:0.00769921, stock:6500.88 },
    { id:"hc6", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-04-1994 GENDER: MALE", price_btc:0.00381356, stock:3350.57 },
    { id:"hc7", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-09-1960 GENDER: MALE", price_btc:0.00917946, stock:7700.17 },
    { id:"hc8", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-11-1974 GENDER: MALE", price_btc:0.00915486, stock:7680.06 },
    { id:"hc9", pet:"Wood forest Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-12-1988 GENDER: FEMALE", price_btc:0.00510877, stock:4400.25 },
    { id:"hc1₀", pet:"Wood forest Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-₀₂-1983 GENDER: MALE", price_btc:0.01115312, stock:9300.20 }
  ],
  "Regions Bank": [
    { id:"ig1", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-09-1982 GENDER: MALE", price_btc:0.00410961, stock:3590.82 },
    { id:"ig2", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-03-1989 GENDER: MALE", price_btc:0.00547211, stock:4694.55 },
    { id:"ig3", pet:"Regions Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-04-1960 GENDER: MALE", price_btc:0.00884289, stock:7427.15 },
    { id:"ig4", pet:"Regions Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-09-1968 GENDER: FEMALE", price_btc:0.00446733, stock:3880.88 },
    { id:"ig5", pet:"Regions Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-06-1950 GENDER: FEMALE", price_btc:0.00708244, stock:6000.52 },
    { id:"ig6", pet:"Regions Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-06-1983 GENDER: FEMALE", price_btc:0.00388140, stock:3405.62 },
    { id:"ig7", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-04-2000 GENDER: FEMALE", price_btc:0.00856269, stock:7200.52 },
    { id:"ig8", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-04-1959 GENDER: FEMALE", price_btc:0.00639516, stock:5442.84 },
    { id:"ig9", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-11-1987 GENDER: MALE", price_btc:0.00429464, stock:3740.46 },
    { id:"ig10", pet:"Regions Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-10-1973 GENDER: MALE", price_btc:0.01078306, stock:9000.23 }
  ],
  "Citizens Bank": [
    { id:"ck1", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-03-1997 GENDER: FEMALE", price_btc:0.00402326, stock:3520.48 },
    { id:"ck2", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-09-2000 GENDER: FEMALE", price_btc:0.00399331, stock:3495.72 },
    { id:"ck3", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-11-1989 GENDER: MALE", price_btc:0.01196921, stock:9961.58 },
    { id:"ck4", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-08-1998 GENDER: MALE", price_btc:0.00443033, stock:3850.38 },
    { id:"ck5", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-03-1982 GENDER: MALE", price_btc:0.00671238, stock:5700.15 },
    { id:"ck6", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-06-1983 GENDER: FEMALE", price_btc:0.00389374, stock:3415.57 },
    { id:"ck7", pet:"Citizens Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-06-1980 GENDER: FEMALE", price_btc:0.00819263, stock:6900.86 },
    { id:"ck8", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-03-1960 GENDER: MALE", price_btc:0.01183859, stock:9855.69 },
    { id:"ck9", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-02-1975 GENDER: MALE", price_btc:0.00439332, stock:3820.83 },
    { id:"ck10", pet:"Citizens Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-12-1987 GENDER: MALE", price_btc:0.01016629, stock:8500.06 }
  ],
  "Navy Federal Bank": [
    { id:"rb1", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-05-1961 GENDER: FEMALE", price_btc:0.00397392, stock:3480.76 },
    { id:"rb2", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-03-1988 GENDER: MALE", price_btc:0.00497309, stock:4290.18 },
    { id:"rb3", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-10-1993 GENDER: FEMALE", price_btc:0.00676172, stock:5740.74 },
    { id:"rb4", pet:"Navy Federal Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-02-1991 GENDER: MALE", price_btc:0.00440566, stock:3830.38 },
    { id:"rb5", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-08-1986 GENDER: MALE", price_btc:0.00769921, stock:6500.73 },
    { id:"rb6", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-10-1965 GENDER: MALE", price_btc:0.00382589, stock:3360.53 },
    { id:"rb7", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-04-1950 GENDER: MALE", price_btc:0.00880940, stock:7400.76 },
    { id:"rb8", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-06-1985 GENDER: MALE", price_btc:0.00462769, stock:4010.02 },
    { id:"rb9", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-06-1972 GENDER: MALE", price_btc:0.00612028, stock:5220.56 },
    { id:"rb10", pet:"Navy Federal Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-04-1975 GENDER: FEMALE", price_btc:0.01090642, stock:9100.42 }
  ],
  "USAA Federal Savings Bank": [
    { id:"hm1", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-07-1987 GENDER: MALE", price_btc:0.00388757, stock:3410.94 },
    { id:"hm4", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-01-1960 GENDER: FEMALE", price_btc:0.00429464, stock:3740.12 },
    { id:"hm5", pet:"USAA Federal Savings Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-11-1995 GENDER: MALE", price_btc:0.00757586, stock:6400.90 },
    { id:"hm6", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-03-2002 GENDER: MALE", price_btc:0.00393691, stock:3450.14 },
    { id:"hm7", pet:"USAA Federal Savings Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-07-1996 GENDER: FEMALE", price_btc:0.00930281, stock:7800.79 },
    { id:"hm8", pet:"USAA Federal Savings Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-11-1984 GENDER: MALE", price_btc:0.00449200, stock:3900.86 },
    { id:"hm9", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-03-1968 GENDER: MALE", price_btc:0.00504710, stock:4350.42 },
    { id:"hm1₀", pet:"USAA Federal Savings Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-02-1982 GENDER: MALE", price_btc:0.01109145, stock:9250.60 }
  ],
  "Discover Bank": [
    { id:"gb1", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1972 GENDER: FEMALE", price_btc:0.00391224, stock:3430.70 },
    { id:"gb2", pet:"Discover Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-03-1963 GENDER: FEMALE", price_btc:0.00504710, stock:4350.69 },
    { id:"gb3", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-08-1951 GENDER: FEMALE", price_btc:0.00690974, stock:5860.80 },
    { id:"gb4", pet:"Discover Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-01-1974 GENDER: FEMALE", price_btc:0.00435631, stock:3790.60 },
    { id:"gb5", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-02-1981 GENDER: FEMALE", price_btc:0.00702076, stock:5950.75 },
    { id:"gb6", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-07-1984 GENDER: FEMALE", price_btc:0.00406027, stock:3550.52 },
    { id:"gb7", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-03-1981 GENDER: FEMALE", price_btc:0.00837766, stock:7050.70 },
    { id:"gb8", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-03-1957 GENDER: FEMALE", price_btc:0.00482506, stock:4170.56 },
    { id:"gb9", pet:"Discover Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-02-2002 GENDER: FEMALE", price_btc:0.00414661, stock:3620.30 },
    { id:"gb10", pet:"Discover Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-08-1979 GENDER: FEMALE", price_btc:0.01072139, stock:8950.96 }
  ],
  "Goldman Sachs Bank": [
    { id:"cs1", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-04-1977 GENDER: MALE", price_btc:0.00408494, stock:3570.95 },
    { id:"cs2", pet:"Goldman Sachs Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-2001 GENDER: MALE", price_btc:0.00512111, stock:4410.98 },
    { id:"cs3", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-05-1998 GENDER: FEMALE", price_btc:0.00698376, stock:5920.32 },
    { id:"cs4", pet:"Goldman Sachs Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-05-1963 GENDER: MALE", price_btc:0.00444266, stock:3860.58 },
    { id:"cs5", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-04-1995 GENDER: FEMALE", price_btc:0.00714412, stock:6050.36 },
    { id:"cs6", pet:"Goldman Sachs Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-11-1981 GENDER: MALE", price_btc:0.00387523, stock:3400.24 },
    { id:"cs7", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-08-1970 GENDER: FEMALE", price_btc:0.00850101, stock:7150.85 },
    { id:"cs8", pet:"Goldman Sachs Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-03-1965 GENDER: MALE", price_btc:0.00366553, stock:3230.52 },
    { id:"cs9", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-08-1965 GENDER: FEMALE", price_btc:0.01043351, stock:8716.63 },
    { id:"cs10", pet:"Goldman Sachs Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-09-1960 GENDER: MALE", price_btc:0.01041300, stock:8700.22 }
  ],
  "TD Group US Holdings LLC": [
    { id:"lg1", pet:"TD Group US Holdings LLC", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-03-1954 GENDER: MALEt", price_btc:0.00413428, stock:3610.24 },
    { id:"lg2", pet:"TD Group US Holdings LLC", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-12-1960 GENDER: MALE", price_btc:0.00493608, stock:4260.09 },
    { id:"lg3", pet:"TD Group US Holdings LLC", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-03-1954 GENDER: FEMALE", price_btc:0.00683573, stock:5800.08 },
    { id:"lg4", pet:"TD Group US Holdings LLC", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-04-1984 GENDER: MALE", price_btc:0.00447967, stock:3890.51 },
    { id:"lg5", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-09-1972 GENDER: FEMALE", price_btc:0.00726747, stock:6150.64 },
    { id:"lg6", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-09-2002 GENDER: MALE", price_btc:0.00388510, stock:3408.29 },
    { id:"lg7", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-01-2002 GENDER: FEMALE", price_btc:0.00862437, stock:7250.86 },
    { id:"lg8", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-01-2001 GENDER: FEMALE", price_btc:0.00355451, stock:3140.07 },
    { id:"lg9", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-08-1997 GENDER: FEMALE", price_btc:0.00424530, stock:3700.12 },
    { id:"lg10", pet:"TD Group US Holdings LLC", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-11-1965 GENDER: MALE", price_btc:0.01084474, stock:9050.19 }
  ],
  "Capital One Financial Corp.": [
    { id:"vc1", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-09-1994 GENDER: FEMALE", price_btc:0.00404793, stock:3540.92 },
    { id:"vc2", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-12-1990 GENDER: FEMALE", price_btc:0.00489907, stock:4230.69 },
    { id:"vc3", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-10-1970 GENDER: FEMALE", price_btc:0.00678639, stock:5760.70 },
    { id:"vc4", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-07-1974 GENDER: FEMALE", price_btc:0.00449817, stock:3905.84 },
    { id:"vc5", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-12-1963 GENDER: FEMALE", price_btc:0.00739083, stock:6250.98 },
    { id:"vc6", pet:"Capital One Financial Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-05-1977 GENDER: MALE", price_btc:0.00510631, stock:4398.84 },
    { id:"vc7", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-08-1965 GENDER: FEMALE", price_btc:0.00874772, stock:7350.15 },
    { id:"vc8", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-04-2001 GENDER: MALE", price_btc:0.00352984, stock:3120.85 },
    { id:"vc9", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-09-1985 GENDER: FEMALE", price_btc:0.00419595, stock:3660.18 },
    { id:"vc10", pet:"Capital One Financial Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-09-1988 GENDER: MALE", price_btc:0.01133816, stock:9450.71 }
  ],
  "Bank of New York Corp.": [
    { id:"lb1", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-11-1977 GENDER: MALE", price_btc:0.00399859, stock:3500.22 },
    { id:"lb2", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-02-1991 GENDER: FEMALE", price_btc:0.00501009, stock:4320.91 },
    { id:"lb3", pet:"Bank of New York Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-10-1957 GENDER: FEMALE", price_btc:0.00693442, stock:5880.08 },
    { id:"lb4", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-02-1980 GENDER: FEMALE", price_btc:0.00441799, stock:3840.32 },
    { id:"lb5", pet:"Bank of New York Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-11-1981 GENDER: FEMALE", price_btc:0.00665070, stock:5650.05 },
    { id:"lb6", pet:"Bank of New York Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-02-1976 GENDER: FEMALE", price_btc:0.00383206, stock:3365.55 },
    { id:"lb7", pet:"Bank of New York Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-03-1985 GENDER: MALE", price_btc:0.00887107, stock:7450.13 },
    { id:"lb8", pet:"Bank of New York Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-11-1992 GENDER: FEMALE", price_btc:0.00456602, stock:3960.34 },
    { id:"lb9", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-08-1984 GENDER: FEMALE", price_btc:0.00372721, stock:3280.07 },
    { id:"lb10", pet:"Bank of New York Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-01-1955 GENDER: FEMALE", price_btc:0.01096809, stock:9150.12 }
  ],
  "State Street Corp.": [
    { id:"cn1", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-04-1963 GENDER: FEMALE", price_btc:0.00394925, stock:3460.70 },
    { id:"cn2", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-08-2000 GENDER: FEMALE", price_btc:0.00508410, stock:4380.56 },
    { id:"cn3", pet:"State Street Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-03-1963 GENDER: MALE", price_btc:0.00702076, stock:5950.46 },
    { id:"cn4", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-10-1984 GENDER: MALE", price_btc:0.00438099, stock:3810.65 },
    { id:"cn5", pet:"State Street Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-06-1963 GENDER: MALE", price_btc:0.00677405, stock:5750.97 },
    { id:"cn6", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-03-1965 GENDER: FEMALE", price_btc:0.00383823, stock:3370.32 },
    { id:"cn7", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-01-1952 GENDER: FEMALE", price_btc:0.00899443, stock:7550.82 },
    { id:"cn8", pet:"State Street Corp.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-01-1969 GENDER: FEMALE", price_btc:0.00467704, stock:4050.15 },
    { id:"cn9", pet:"State Street Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-09-1992 GENDER: MALE", price_btc:0.00380122, stock:3340.26 },
    { id:"cn10", pet:"State Street Corp.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-12-1998 GENDER: FEMALE", price_btc:0.01102977, stock:9200.10 }
  ],
  "Fifth Third Bancorp": [
    { id:"gf1", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-08-1966 GENDER: FEMALE", price_btc:0.00402326, stock:3520.93 },
    { id:"gf2", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-01-1959 GENDER: MALE", price_btc:0.00515812, stock:4440.97 },
    { id:"gf3", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-01-1991 GENDER: MALE", price_btc:0.00707010, stock:5990.05 },
    { id:"gf4", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-11-1952 GENDER: MALE", price_btc:0.00439332, stock:3820.13 },
    { id:"gf5", pet:"Fifth Third Bancorp", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-02-1986 GENDER: FEMALE", price_btc:0.00689741, stock:5850.58 },
    { id:"gf6", pet:"Fifth Third Bancorp", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-12-1982 GENDER: FEMALE", price_btc:0.00384440, stock:3375.50 },
    { id:"gf7", pet:"Fifth Third Bancorp", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-1973 GENDER: FEMALE", price_btc:0.00911778, stock:7650.91 },
    { id:"gf8", pet:"Fifth Third Bancorp", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-07-1974 GENDER: MALE", price_btc:0.00472638, stock:4090.38 },
    { id:"gf9", pet:"Fifth Third Bancorp", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-07-1998 GENDER: FEMALE", price_btc:0.00387523, stock:3400.90 },
    { id:"gf10", pet:"Fifth Third Bancorp", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-06-1964 GENDER: MALE", price_btc:0.01115312, stock:9300.27 }
  ],
  "Silicon Valley Bank": [
    { id:"ko1", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-12-1989 GENDER: MALE", price_btc:0.00412194, stock:3600.80 },
    { id:"ko2", pet:"Silicon Valley Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1986 GENDER: MALE", price_btc:0.00521979, stock:4490.23 },
    { id:"ko3", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-05-1970 GENDER: MALE", price_btc:0.00711945, stock:6030.92 },
    { id:"ko4", pet:"Silicon Valley Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-08-1957 GENDER: MALE", price_btc:0.00445500, stock:3870.51 },
    { id:"ko5", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-04-1974 GENDER: FEMALE", price_btc:0.00745250, stock:6300.34 },
    { id:"ko6", pet:"Silicon Valley Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-04-1981 GENDER: MALE", price_btc:0.00389004, stock:3412.91 },
    { id:"ko7", pet:"Silicon Valley Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-06-1991 GENDER: MALE", price_btc:0.00831598, stock:7000.46 },
    { id:"ko8", pet:"Silicon Valley Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-01-1991 GENDER: FEMALE", price_btc:0.00370254, stock:3260.94 },
    { id:"ko9", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-10-1953 GENDER: FEMALE", price_btc:0.00426997, stock:3720.88 },
    { id:"ko10", pet:"Silicon Valley Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-09-1995 GENDER: MALE", price_btc:0.01139983, stock:9500.82 }
  ],
  "M & T Bank": [
    { id:"ko1", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-11-1982 GENDER: FEMALEe", price_btc:0.00412194, stock:3600.31 },
    { id:"ko2", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-07-1989 GENDER: FEMALEr", price_btc:0.00521979, stock:4490.37 },
    { id:"ko3", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-06-1979 GENDER: FEMALE", price_btc:0.00711945, stock:6030.22 },
    { id:"ko4", pet:"M & T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-03-1950 GENDER: FEMALE", price_btc:0.00445500, stock:3870.30 },
    { id:"ko5", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-07-1989 GENDER: FEMALE", price_btc:0.00745250, stock:6300.81 },
    { id:"ko6", pet:"M & T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-01-1973 GENDER: MALE", price_btc:0.00389004, stock:3412.02 },
    { id:"ko7", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-12-1961 GENDER: FEMALE", price_btc:0.00831598, stock:7000.63 },
    { id:"ko8", pet:"M & T Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-07-1953 GENDER: MALE", price_btc:0.00370254, stock:3260.55 },
    { id:"ko9", pet:"M & T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-03-1953 GENDER: FEMALE", price_btc:0.00426997, stock:3720.75 },
    { id:"ko10", pet:"M & T Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-08-2004 GENDER: FEMALE", price_btc:0.01139983, stock:9500.52 }
  ],
  "HSBC Holdings": [
    { id:"p1", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-07-1981 GENDER: MALE", price_btc:0.00389004, stock:3412.86 },
    { id:"p2", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-11-1989 GENDER: MALE", price_btc:0.00477202, stock:4127.95 },
    { id:"p3", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-09-1984 GENDER: FEMALE", price_btc:0.00582793, stock:4983.63 },
    { id:"p4", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-08-1980 GENDER: FEMALE", price_btc:0.00707504, stock:5994.27 },
    { id:"p5", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-07-1994 GENDER: FEMALE", price_btc:0.00818399, stock:6893.27 },
    { id:"p6", pet:"HSBC Holdings", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-11-1963 GENDER: FEMALE", price_btc:0.00804584, stock:6781.11 },
    { id:"p7", pet:"HSBC Holdings", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1971 GENDER: MALE", price_btc:0.00933489, stock:7826.14 },
    { id:"p8", pet:"HSBC Holdings", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-12-1962 GENDER: MALE", price_btc:0.01091752, stock:9109.05 },
    { id:"p9", pet:"HSBC Holdings", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-11-2004 GENDER: MALE", price_btc:0.01119136, stock:9331.13 },
    { id:"p10", pet:"HSBC Holdings", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-1992 GENDER: MALE", price_btc:0.01199933, stock:9986.48 }
  ],
  "Lloyds Banking Group": [
    { id:"si1", pet:"Lloyds Banking Group", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-03-1957 GENDER: MALE", price_btc:0.01168035, stock:9727.41 },
    { id:"si2", pet:"Lloyds Banking Group", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-05-1990 GENDER: FEMALE", price_btc:0.00411687, stock:3595.89 },
    { id:"si3", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-07-1998 GENDER: MALE", price_btc:0.00597652, stock:5103.46 },
    { id:"si4", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-05-1970 GENDER: MALE", price_btc:0.00497042, stock:4287.84 },
    { id:"si5", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-01-1955 GENDER: MALE", price_btc:0.01017494, stock:8507.01 },
    { id:"si6", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1964 GENDER: MALE", price_btc:0.01008028, stock:8430.27 },
    { id:"si7", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-07-1959 GENDER: FEMALE", price_btc:0.01078100, stock:8998.33 },
    { id:"si8", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-09-1979 GENDER: FEMALE", price_btc:0.00358360, stock:3163.58 },
    { id:"si9", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-05-1970 GENDER: FEMALE", price_btc:0.00363019, stock:3201.35 },
    { id:"si10", pet:"Lloyds Banking Group", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-07-1956 GENDER: FEMALE", price_btc:0.00952031, stock:7976.32 }
  ],
  "Banking Group of Scotland": [
    { id:"mc1", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-10-1969 GENDER: FEMALE", price_btc:0.00428972, stock:3736.01 },
    { id:"mc2", pet:"Banking Group of Scotland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-03-1969 GENDER: MALE", price_btc:0.00724693, stock:6133.35 },
    { id:"mc3", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-03-1991 GENDER: FEMALE", price_btc:0.00911544, stock:7648.10 },
    { id:"mc4", pet:"Banking Group of Scotland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-12-1998 GENDER: MALE", price_btc:0.00596781, stock:5096.40 },
    { id:"mc5", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-07-2002 GENDER: MALE", price_btc:0.00745791, stock:6304.38 },
    { id:"mc6", pet:"Banking Group of Scotland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-02-1995 GENDER: FEMALE", price_btc:0.00541895, stock:4651.45 },
    { id:"mc7", pet:"Banking Group of Scotland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-12-1968 GENDER: FEMALE", price_btc:0.00737042, stock:6233.46 },
    { id:"mc8", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-02-1969 GENDER: MALE", price_btc:0.00769910, stock:6499.91 },
    { id:"mc9", pet:"Banking Group of Scotland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-12-1969 GENDER: FEMALE", price_btc:0.00912322, stock:7654.41 },
    { id:"mc10", pet:"Banking Group of Scotland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-10-1961 GENDER: FEMALE", price_btc:0.01199740, stock:9984.43 }
  ],
  "Barclays": [
    { id:"be1", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-06-1967 GENDER: FEMALE", price_btc:0.00500384, stock:4314.93 },
    { id:"be2", pet:"Barclays", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-10-1959 GENDER: MALE", price_btc:0.01003206, stock:8391.18 },
    { id:"be3", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-01-1994 GENDER: FEMALE", price_btc:0.00741083, stock:6266.22 },
    { id:"be4", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-06-1960 GENDER: FEMALE", price_btc:0.00647118, stock:5504.47 },
    { id:"be5", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-08-1960 GENDER: FEMALE", price_btc:0.00894041, stock:7506.21 },
    { id:"be6", pet:"Barclays", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-05-1961 GENDER: FEMALE", price_btc:0.00711654, stock:6027.64 },
    { id:"be7", pet:"Barclays", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-04-1971 GENDER: MALE", price_btc:0.00846531, stock:7121.06 },
    { id:"be8", pet:"Barclays", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-02-2001 GENDER: MALE", price_btc:0.00933025, stock:7822.24 },
    { id:"be9", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-08-1975 GENDER: FEMALE", price_btc:0.00918336, stock:7703.16 },
    { id:"be10", pet:"Barclays", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-03-1982 GENDER: FEMALE", price_btc:0.00529832, stock:4553.66 }
  ],
  "Standard Chartered": [
    { id:"bg1", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-09-1982 GENDER: MALE", price_btc:0.00404793, stock:3540.84 },
    { id:"bg2", pet:"Standard Chartered", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-02-1955 GENDER: FEMALE", price_btc:0.00496075, stock:4280.75 },
    { id:"bg3", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-09-1960 GENDER: MALE", price_btc:0.00672471, stock:5710.50 },
    { id:"bg4", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-06-1990 GENDER: MALE", price_btc:0.00439332, stock:3820.15 },
    { id:"bg5", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-08-2002 GENDER: MALE", price_btc:0.00767454, stock:6480.55 },
    { id:"bg6", pet:"Standard Chartered", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-05-1971 GENDER: FEMALE", price_btc:0.00382589, stock:3360.38 },
    { id:"bg7", pet:"Standard Chartered", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-05-1965 GENDER: MALE", price_btc:0.00879706, stock:7390.96 },
    { id:"bg8", pet:"Standard Chartered", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-05-1975 GENDER: MALE", price_btc:0.00464003, stock:4020.06 },
    { id:"bg9", pet:"Standard Chartered", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-01-1957 GENDER: FEMALE", price_btc:0.00610794, stock:5210.61 },
    { id:"bg10", pet:"Standard Chartered", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-11-1968 GENDER: FEMALE", price_btc:0.01088175, stock:9080.29 }
  ],
  "Santander UK": [
    { id:"po1", pet:"Santander UK", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-05-1984 GENDER: FEMALE", price_btc:0.00396158, stock:3470.62 },
    { id:"po2", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-01-2000 GENDER: MALE", price_btc:0.00512111, stock:4410.07 },
    { id:"po3", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-02-1984 GENDER: MALE", price_btc:0.00699609, stock:5930.89 },
    { id:"po4", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-02-2001 GENDER: MALE", price_btc:0.00444266, stock:3860.27 },
    { id:"po5", pet:"Santander UK", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-03-1985 GENDER: FEMALE", price_btc:0.00716879, stock:6070.51 },
    { id:"po6", pet:"Santander UK", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-05-1980 GENDER: MALE", price_btc:0.00388757, stock:3410.37 },
    { id:"po7", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-09-1974 GENDER: FEMALE", price_btc:0.00851335, stock:7160.94 },
    { id:"po8", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-11-1953 GENDER: MALE", price_btc:0.00367787, stock:3240.77 },
    { id:"po9", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-08-1982 GENDER: FEMALE", price_btc:0.00435631, stock:3790.19 },
    { id:"po10", pet:"Santander UK", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-12-1991 GENDER: FEMALE", price_btc:0.01043767, stock:8720.49 }
  ],
  "Nationwide Building Soc.": [
    { id:"rg1", pet:"Nationwide Building Soc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-02-1982 GENDER: FEMALE", price_btc:0.00402326, stock:3520.54 },
    { id:"rg2", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-05-1966 GENDER: MALE", price_btc:0.00502243, stock:4330.01 },
    { id:"rg3", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-11-1982 GENDER: MALE", price_btc:0.00692208, stock:5870.33 },
    { id:"rg4", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-04-1964 GENDER: MALE", price_btc:0.00441799, stock:3840.06 },
    { id:"rg5", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-12-1961 GENDER: MALE", price_btc:0.00663837, stock:5640.21 },
    { id:"rg6", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-05-1959 GENDER: MALE", price_btc:0.00383206, stock:3365.94 },
    { id:"rg7", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-07-1987 GENDER: FEMALE", price_btc:0.00885874, stock:7440.61 },
    { id:"rg8", pet:"Nationwide Building Soc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-01-1997 GENDER: FEMALE", price_btc:0.00455368, stock:3950.38 },
    { id:"rg9", pet:"Nationwide Building Soc.", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-06-1953 GENDER: MALE", price_btc:0.00372721, stock:3280.22 },
    { id:"rg10", pet:"Nationwide Building Soc.", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-06-1968 GENDER: MALE", price_btc:0.01095576, stock:9140.25 }
  ],
  "Schroders": [
    { id:"sx1", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-09-1961 GENDER: FEMALE", price_btc:0.00413428, stock:3610.87 },
    { id:"sx2", pet:"Schroders", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-08-1996 GENDER: MALE", price_btc:0.00492374, stock:4250.33 },
    { id:"sx3", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-10-2005 GENDER: FEMALE", price_btc:0.00682340, stock:5790.07 },
    { id:"sx4", pet:"Schroders", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-03-1996 GENDER: MALE", price_btc:0.00446733, stock:3880.76 },
    { id:"sx5", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-04-1952 GENDER: MALE", price_btc:0.00725514, stock:6140.65 },
    { id:"sx6", pet:"Schroders", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-05-1965 GENDER: FEMALE", price_btc:0.00388140, stock:3405.33 },
    { id:"sx7", pet:"Schroders", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-10-1996 GENDER: MALE", price_btc:0.00861203, stock:7240.48 },
    { id:"sx8", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-05-1988 GENDER: FEMALE", price_btc:0.00354218, stock:3130.92 },
    { id:"sx9", pet:"Schroders", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-02-1965 GENDER: FEMALE", price_btc:0.00423296, stock:3690.60 },
    { id:"sx10", pet:"Schroders", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-01-2003 GENDER: FEMALE", price_btc:0.01083240, stock:9040.71 }
  ],
  "Close Brothers Group plc": [
    { id:"csp1", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-07-1984 GENDER: FEMALE", price_btc:0.00393691, stock:3450.56 },
    { id:"csp2", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-1975 GENDER: MALE", price_btc:0.00505943, stock:4360.07 },
    { id:"csp3", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-10-1995 GENDER: FEMALE", price_btc:0.00688507, stock:5840.53 },
    { id:"csp4", pet:"Close Brothers Group plc", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-12-1969 GENDER: FEMALE", price_btc:0.00440566, stock:3830.09 },
    { id:"csp5", pet:"Close Brothers Group plc", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-04-1972 GENDER: MALE", price_btc:0.00710711, stock:6020.72 },
    { id:"csp6", pet:"Close Brothers Group plc", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-01-1952 GENDER: FEMALE", price_btc:0.00385056, stock:3380.74 },
    { id:"csp7", pet:"Close Brothers Group plc", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-10-1980 GENDER: MALE", price_btc:0.00845167, stock:7110.74 },
    { id:"csp8", pet:"Close Brothers Group plc", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-11-1965 GENDER: MALE", price_btc:0.00364086, stock:3210.88 },
    { id:"csp9", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-02-1967 GENDER: MALE", price_btc:0.00431931, stock:3760.19 },
    { id:"csp10", pet:"Close Brothers Group plc", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-05-1962 GENDER: FEMALE", price_btc:0.01038833, stock:8680.79 }
  ],
  "Coventry Building Society": [
    { id:"cnr1", pet:"Coventry Building Society", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-10-2003 GENDER: FEMALE", price_btc:0.00398625, stock:3490.13 },
    { id:"cnr2", pet:"Coventry Building Society", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-10-1980 GENDER: MALE", price_btc:0.00499776, stock:4310.03 },
    { id:"cnr3", pet:"Coventry Building Society", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-05-1962 GENDER: FEMALE", price_btc:0.00690974, stock:5860.78 },
    { id:"cnr4", pet:"Coventry Building Society", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-01-1989 GENDER: FEMALE", price_btc:0.00443033, stock:3850.68 },
    { id:"cnr5", pet:"Coventry Building Society", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-01-1987 GENDER: MALE", price_btc:0.00668771, stock:5680.87 },
    { id:"cnr6", pet:"Coventry Building Society", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-09-1958 GENDER: MALE", price_btc:0.00383823, stock:3370.92 },
    { id:"cnr7", pet:"Coventry Building Society", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-04-1991 GENDER: FEMALE", price_btc:0.00888341, stock:7460.01 },
    { id:"cnr8", pet:"Coventry Building Society", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 19-01-1967 GENDER: MALE", price_btc:0.00457835, stock:3970.91 },
    { id:"cnr9", pet:"Coventry Building Society", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-06-1956 GENDER: MALE", price_btc:0.00375188, stock:3300.96 },
    { id:"cnr10", pet:"Coventry Building Society", emoji:"$", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-07-1951 GENDER: FEMALE", price_btc:0.01098043, stock:9160.98 }
  ],
  "Royal Bank of Canada": [
    { id:"ag1", pet:"Royal Bank of Canada", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-04-2005 GENDER: MALE", price_btc:0.00408522, stock:3570.23 },
    { id:"ag2", pet:"Royal Bank of Canada", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-08-1980 GENDER: MALE", price_btc:0.00476394, stock:4120.45 },
    { id:"ag3", pet:"Royal Bank of Canada", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-05-1977 GENDER: FEMALE", price_btc:0.00491223, stock:4240.67 },
    { id:"ag4", pet:"Royal Bank of Canada", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-12-1988 GENDER: FEMALE", price_btc:0.00550461, stock:4720.89 },
    { id:"ag5", pet:"Royal Bank of Canada", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-01-1990 GENDER: FEMALE", price_btc:0.00383851, stock:3370.23 },
    { id:"ag6", pet:"Royal Bank of Canada", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-06-1991 GENDER: FEMALE", price_btc:0.00599748, stock:5120.45 },
    { id:"ag7", pet:"Royal Bank of Canada", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-01-1989 GENDER: MALE", price_btc:0.00651584, stock:5540.67 },
    { id:"ag8", pet:"Royal Bank of Canada", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-07-1980 GENDER: MALE", price_btc:0.00413784, stock:3612.89 },
    { id:"ag9", pet:"Royal Bank of Canada", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-10-1952 GENDER: FEMALE", price_btc:0.00445528, stock:3870.23 }
  ],
  "Toronto-Dominion Bank": [
    { id:"co1", pet:"Toronto-Dominion Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-03-1953 GENDER: FEMALE", price_btc:0.00459333, stock:3982.14 },
    { id:"co2", pet:"Toronto-Dominion Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-09-1971 GENDER: FEMALE", price_btc:0.00526810, stock:4529.16 },
    { id:"co3", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-03-2001 GENDER: MALE", price_btc:0.00871786, stock:7325.79 },
    { id:"co4", pet:"Toronto-Dominion Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-06-1967 GENDER: FEMALE", price_btc:0.00954984, stock:8000.26 },
    { id:"co5", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-10-1985 GENDER: MALE", price_btc:0.00453762, stock:3936.98 },
    { id:"co6", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-08-2001 GENDER: FEMALE", price_btc:0.00986382, stock:8254.79 },
    { id:"co7", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-10-1952 GENDER: MALE", price_btc:0.00568898, stock:4870.36 },
    { id:"co8", pet:"Toronto-Dominion Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-08-1960 GENDER: FEMALE", price_btc:0.00484662, stock:4187.48 },
    { id:"co9", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-11-1991 GENDER: MALE", price_btc:0.00582983, stock:4984.54 },
    { id:"co10", pet:"Toronto-Dominion Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-12-1964 GENDER: FEMALE", price_btc:0.00904071, stock:7587.52 }
  ],
  "Bank of Montreal": [
    { id:"ma1", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-1987 GENDER: FEMALE", price_btc:0.00409314, stock:3576.65 },
    { id:"ma2", pet:"Bank of Montreal", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-07-1951 GENDER: FEMALE", price_btc:0.00448675, stock:3895.74 },
    { id:"ma3", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-08-1956 GENDER: MALE", price_btc:0.00492883, stock:4254.12 },
    { id:"ma4", pet:"Bank of Montreal", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-01-1991 GENDER: MALE", price_btc:0.00526588, stock:4527.36 },
    { id:"ma5", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-12-1960 GENDER: FEMALE", price_btc:0.00415308, stock:3625.24 },
    { id:"ma7", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-05-1981 GENDER: FEMALE", price_btc:0.01089312, stock:9089.22 },
    { id:"ma8", pet:"Bank of Montreal", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-02-1995 GENDER: FEMALE", price_btc:0.00419533, stock:3659.49 },
    { id:"ma9", pet:"Bank of Montreal", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-11-1995 GENDER: FEMALE", price_btc:0.00442080, stock:3842.28 },
    { id:"ma10", pet:"Bank of Montreal", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-03-1995 GENDER: MALE", price_btc:0.00463746, stock:4017.92 }
  ],
  "Canadian Imperial Bank of Commerce": [
    { id:"bu1", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-11-1986 GENDER: MALE", price_btc:0.00583329, stock:4987.35 },
    { id:"bu2", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-01-1972 GENDER: MALE", price_btc:0.00510352, stock:4395.74 },
    { id:"bu3", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-01-1974 GENDER: MALE", price_btc:0.00369529, stock:3254.12 },
    { id:"bu4", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-09-1986 GENDER: MALE", price_btc:0.00563594, stock:4827.36 },
    { id:"bu5", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 11-05-1992 GENDER: FEMALE", price_btc:0.00489320, stock:4225.24 },
    { id:"bu6", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-06-1977 GENDER: FEMALE", price_btc:0.00531917, stock:4570.56 },
    { id:"bu7", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-08-1975 GENDER: FEMALE", price_btc:0.00618265, stock:5270.56 },
    { id:"bu8", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-06-1979 GENDER: FEMALE", price_btc:0.00382523, stock:3359.46 },
    { id:"bu9", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-09-1951 GENDER: MALE", price_btc:0.00394527, stock:3456.78 },
    { id:"bu10", pet:"Canadian Imperial Bank of Commerce", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-01-2002 GENDER: MALE", price_btc:0.00512835, stock:4415.87 }
  ],
  "Bank of Nova Scotia": [
    { id:"zf1", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-07-2001 GENDER: FEMALE", price_btc:0.00391224, stock:3430.04 },
    { id:"zf2", pet:"Bank of Nova Scotia", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-03-1959 GENDER: MALE", price_btc:0.00509644, stock:4390.31 },
    { id:"zf3", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-09-1969 GENDER: FEMALE", price_btc:0.00703310, stock:5960.05 },
    { id:"zf4", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-12-2003 GENDER: MALE", price_btc:0.00436865, stock:3800.32 },
    { id:"zf5", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-11-1963 GENDER: MALE", price_btc:0.00678639, stock:5760.84 },
    { id:"zf6", pet:"Bank of Nova Scotia", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-02-1974 GENDER: FEMALE", price_btc:0.00384440, stock:3375.30 },
    { id:"zf7", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-02-1996 GENDER: MALE", price_btc:0.00900676, stock:7560.68 },
    { id:"zf8", pet:"Bank of Nova Scotia", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-07-1979 GENDER: FEMALE", price_btc:0.00468937, stock:4060.04 },
    { id:"zf9", pet:"Bank of Nova Scotia", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-07-1953 GENDER: FEMALE", price_btc:0.00381356, stock:3350.99 },
    { id:"zf10", pet:"Bank of Nova Scotia", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-07-1975 GENDER: FEMALE", price_btc:0.01104211, stock:9210.37 }
  ],
  "Canadian Western Bank": [
    { id:"af1", pet:"Canadian Western Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-07-1961 GENDER: FEMALE", price_btc:0.00403559, stock:3530.89 },
    { id:"af2", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-01-1953 GENDER: FEMALE", price_btc:0.00517045, stock:4450.40 },
    { id:"af3", pet:"Canadian Western Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-01-1976 GENDER: MALE", price_btc:0.00705777, stock:5980.50 },
    { id:"af4", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-01-2004 GENDER: FEMALE", price_btc:0.00438099, stock:3810.61 },
    { id:"af5", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-11-1987 GENDER: FEMALE", price_btc:0.00688507, stock:5840.75 },
    { id:"af6", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-06-2001 GENDER: MALE", price_btc:0.00385056, stock:3380.29 },
    { id:"af7", pet:"Canadian Western Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 13-03-2001 GENDER: MALE", price_btc:0.00910545, stock:7640.74 },
    { id:"af8", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-11-1990 GENDER: FEMALE", price_btc:0.00471404, stock:4080.23 },
    { id:"af9", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-04-1979 GENDER: FEMALE", price_btc:0.00388757, stock:3410.18 },
    { id:"af10", pet:"Canadian Western Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-08-1997 GENDER: MALE", price_btc:0.01114079, stock:9290.31 }
  ],
  "Digital Commerce Bank": [
    { id:"gp1", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-07-1988 GENDER: FEMALE", price_btc:0.00399859, stock:3500.01 },
    { id:"gp2", pet:"Digital Commerce Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-03-2004 GENDER: MALE", price_btc:0.00513345, stock:4420.50 },
    { id:"gp3", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-07-2000 GENDER: MALE", price_btc:0.00702076, stock:5950.74 },
    { id:"gp4", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-09-2002 GENDER: MALE", price_btc:0.00435631, stock:3790.96 },
    { id:"gp5", pet:"Digital Commerce Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-10-1960 GENDER: FEMALE", price_btc:0.00687274, stock:5830.81 },
    { id:"gp6", pet:"Digital Commerce Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-05-1964 GENDER: FEMALE", price_btc:0.00383206, stock:3365.22 },
    { id:"gp7", pet:"Digital Commerce Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 29-04-1982 GENDER: MALE", price_btc:0.00908078, stock:7620.35 },
    { id:"gp8", pet:"Digital Commerce Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-2004 GENDER: FEMALE", price_btc:0.00470171, stock:4070.86 },
    { id:"gp9", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-12-1961 GENDER: FEMALE", price_btc:0.00386290, stock:3390.41 },
    { id:"gp10", pet:"Digital Commerce Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-06-1996 GENDER: FEMALE", price_btc:0.01111612, stock:9270.75 }
  ],
  "ANZ Bank": [
    { id:"rs1", pet:"ANZ Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-09-1962 GENDER: FEMALE", price_btc:0.00412194, stock:3600.61 },
    { id:"rs2", pet:"ANZ Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-05-1998 GENDER: FEMALE", price_btc:0.00520746, stock:4480.74 },
    { id:"rs3", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-04-1976 GENDER: FEMALE", price_btc:0.00710711, stock:6020.42 },
    { id:"rs4", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-06-1972 GENDER: MALE", price_btc:0.00444266, stock:3860.77 },
    { id:"rs5", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 02-02-1990 GENDER: MALE", price_btc:0.00744017, stock:6290.31 },
    { id:"rs6", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-03-1973 GENDER: MALE", price_btc:0.00388757, stock:3410.22 },
    { id:"rs7", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-02-1977 GENDER: FEMALE", price_btc:0.00832832, stock:7010.88 },
    { id:"rs8", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-11-1969 GENDER: FEMALE", price_btc:0.00369020, stock:3250.71 },
    { id:"rs9", pet:"ANZ Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-12-2002 GENDER: FEMALE", price_btc:0.00425763, stock:3710.35 },
    { id:"rs10", pet:"ANZ Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-02-1964 GENDER: MALE", price_btc:0.01138750, stock:9490.88 }
  ],
  "Commonwealth Bank": [
    { id:"fe1", pet:"Commonwealth Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-11-1971 GENDER: FEMALE", price_btc:0.00720579, stock:6100.15 },
    { id:"fe2", pet:"Commonwealth Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-04-1986 GENDER: MALE", price_btc:0.01142230, stock:9518.21 },
    { id:"fe3", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-01-1982 GENDER: MALE", price_btc:0.00390443, stock:3423.67 },
    { id:"fe4", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-09-1970 GENDER: MALE", price_btc:0.01127648, stock:9400.95 },
    { id:"fe5", pet:"Commonwealth Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-01-1973 GENDER: FEMALE", price_btc:0.00683573, stock:5800.12 },
    { id:"fe6", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-05-1953 GENDER: MALE", price_btc:0.00473871, stock:4100.31 },
    { id:"fe7", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-11-1968 GENDER: MALE", price_btc:0.00843934, stock:7100.92 },
    { id:"fe8", pet:"Commonwealth Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-08-1974 GENDER: MALE", price_btc:0.01163577, stock:9691.27 },
    { id:"fe9", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-01-1994 GENDER: MALE", price_btc:0.00407260, stock:3560.95 },
    { id:"fe10", pet:"Commonwealth Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-10-1988 GENDER: FEMALE", price_btc:0.01053635, stock:8800.23 }
  ],
  "National Australian Bank": [
    { id:"ta1", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-05-1997 GENDER: MALE", price_btc:0.00558269, stock:4784.19 },
    { id:"ta2", pet:"National Australian Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-04-1976 GENDER: MALE", price_btc:0.00608798, stock:5193.82 },
    { id:"ta3", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-02-2004 GENDER: FEMALE", price_btc:0.00343116, stock:3040.56 },
    { id:"ta4", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-04-1976 GENDER: FEMALE", price_btc:0.00930281, stock:7800.07 },
    { id:"ta5", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 27-09-1964 GENDER: FEMALE", price_btc:0.00794592, stock:6700.75 },
    { id:"ta6", pet:"National Australian Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-06-1984 GENDER: MALE", price_btc:0.00412194, stock:3600.98 },
    { id:"ta7", pet:"National Australian Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-09-2002 GENDER: MALE", price_btc:0.00942617, stock:7900.46 },
    { id:"ta8", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-04-1988 GENDER: FEMALE", price_btc:0.00775703, stock:6546.87 },
    { id:"ta9", pet:"National Australian Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-10-1970 GENDER: FEMALE", price_btc:0.00406815, stock:3556.39 },
    { id:"ta10", pet:"National Australian Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-05-2000 GENDER: FEMALE", price_btc:0.01090642, stock:9100.83 }
  ],
  "Westpac Bank": [
    { id:"ax1", pet:"Westpac Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 12-05-1992 GENDER: FEMALE", price_btc:0.00562176, stock:4815.86 },
    { id:"ax2", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-01-2000 GENDER: MALE", price_btc:0.00989984, stock:8283.99 },
    { id:"ax3", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-05-1977 GENDER: FEMALE", price_btc:0.00858872, stock:7221.10 },
    { id:"ax4", pet:"Westpac Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-09-1999 GENDER: MALE", price_btc:0.00489720, stock:4228.48 },
    { id:"ax5", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-03-1984 GENDER: MALE", price_btc:0.00745250, stock:6300.98 },
    { id:"ax6", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-09-1956 GENDER: FEMALE", price_btc:0.00368098, stock:3242.52 },
    { id:"ax7", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-11-1987 GENDER: FEMALE", price_btc:0.00868604, stock:7300.63 },
    { id:"ax8", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-01-1950 GENDER: MALE", price_btc:0.00494890, stock:4270.39 },
    { id:"ax9", pet:"Westpac Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 22-05-1964 GENDER: MALE", price_btc:0.00422063, stock:3680.89 },
    { id:"ax10", pet:"Westpac Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-05-1972 GENDER: MALE", price_btc:0.01139983, stock:9500.90 }
  ],
  "Bank of Queensland": [
    { id:"sg1", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-05-2003 GENDER: FEMALE", price_btc:0.00757586, stock:6400.32 },
    { id:"sg2", pet:"Bank of Queensland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 18-11-1970 GENDER: MALE", price_btc:0.00941449, stock:7890.53 },
    { id:"sg3", pet:"Bank of Queensland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-03-1974 GENDER: MALE", price_btc:0.00714765, stock:6052.86 },
    { id:"sg4", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 09-02-1952 GENDER: FEMALE", price_btc:0.00979623, stock:8200.30 },
    { id:"sg5", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-03-1950 GENDER: MALE", price_btc:0.00438697, stock:3814.85 },
    { id:"sg6", pet:"Bank of Queensland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 20-12-1975 GENDER: MALE", price_btc:0.00498542, stock:4300.25 },
    { id:"sg7", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-08-1965 GENDER: MALE", price_btc:0.00806927, stock:6800.53 },
    { id:"sg8", pet:"Bank of Queensland", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 08-07-1971 GENDER: FEMALE", price_btc:0.00509676, stock:4390.26 },
    { id:"sg9", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 16-07-1993 GENDER: FEMALE", price_btc:0.00449200, stock:3900.51 },
    { id:"sg10", pet:"Bank of Queensland", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 07-01-1952 GENDER: MALE", price_btc:0.01028965, stock:8600.07 }
  ],
  "Macquarie Bank": [
    { id:"hc1", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 30-05-1976 GENDER: FEMALE", price_btc:0.00436865, stock:3800.09 },
    { id:"hc2", pet:"Macquarie Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 24-06-1986 GENDER: MALE", price_btc:0.00980145, stock:8204.23 },
    { id:"hc3", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-07-1993 GENDER: MALE", price_btc:0.00521570, stock:4486.68 },
    { id:"hc4", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 03-06-1959 GENDER: FEMALE", price_btc:0.00905611, stock:7600.48 },
    { id:"hc5", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 17-07-2005 GENDER: MALE", price_btc:0.00769921, stock:6500.76 },
    { id:"hc6", pet:"Macquarie Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 21-05-1990 GENDER: FEMALE", price_btc:0.00399859, stock:3500.65 },
    { id:"hc7", pet:"Macquarie Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 04-04-1980 GENDER: MALE", price_btc:0.00917946, stock:7700.91 },
    { id:"hc8", pet:"Macquarie Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-07-1978 GENDER: MALE", price_btc:0.00637441, stock:5426.02 },
    { id:"hc9", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-09-2004 GENDER: MALE", price_btc:0.00510877, stock:4400.33 },
    { id:"hc10", pet:"Macquarie Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 01-11-1987 GENDER: FEMALE", price_btc:0.01115312, stock:9300.66 }
  ],
  "Bendigo Bank": [
    { id:"ig1", pet:"Bendigo Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 31-08-1979 GENDER: FEMALE", price_btc:0.00695909, stock:5900.67 },
    { id:"ig2", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 10-03-1968 GENDER: MALE", price_btc:0.00533969, stock:4587.20 },
    { id:"ig3", pet:"Bendigo Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 25-03-2005 GENDER: MALE", price_btc:0.01049994, stock:8770.48 },
    { id:"ig4", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 15-03-2003 GENDER: FEMALE", price_btc:0.01053635, stock:8800.35 },
    { id:"ig5", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 14-05-2000 GENDER: MALE", price_btc:0.00948477, stock:7947.51 },
    { id:"ig6", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 23-03-1980 GENDER: FEMALE", price_btc:0.00467704, stock:4050.56 },
    { id:"ig7", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 28-02-1997 GENDER: MALE", price_btc:0.00856269, stock:7200.22 },
    { id:"ig8", pet:"Bendigo Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 26-09-1969 GENDER: FEMALE", price_btc:0.01016531, stock:8499.20 },
    { id:"ig9", pet:"Bendigo Bank", emoji:"", description:"CHECKINGS ONLY + BANK ACCESS ONLY DOB: 05-10-1973 GENDER: FEMALE", price_btc:0.00429464, stock:3740.02 },
    { id:"ig10", pet:"Bendigo Bank", emoji:"", description:"SAVINGS + CHECKINGS ONLY + BANK ACCESS ONLY DOB: 06-08-1963 GENDER: FEMALE", price_btc:0.01078306, stock:9000.82 }
  ]
};


// ─── MOCK TRANSACTIONS (homepage — prices shown in USD) ───────────────────────
const MOCK_TRANSACTIONS = [
  { id: 1, pet_type: "JPMorgan Chase and Co.", user_name: "ALE****", amount_btc: 0.00520000, created_at: "2025-05-10" },
  { id: 2, pet_type: "HSBC Holdings",      user_name: "BEN****", amount_btc: 0.0090000, created_at: "2025-05-11" },
  { id: 3, pet_type: "Commonwealth Bank",            user_name: "CHR****", amount_btc: 0.00310000, created_at: "2025-05-12" },
  { id: 4, pet_type: "Bank of Montreal", user_name: "DAV****", amount_btc: 0.00390000, created_at: "2025-05-13" },
  { id: 5, pet_type: "Barclays",      user_name: "EUG****", amount_btc: 0.0070000, created_at: "2025-05-14" },
  { id: 6, pet_type: "Westpac Bank",   user_name: "FRA****", amount_btc: 0.00580000, created_at: "2025-05-15" },
  { id: 7, pet_type: "Citigroup Inc.",   user_name: "GAB****", amount_btc: 0.00660000, created_at: "2025-05-16" },
  { id: 8, pet_type: "ANZ Bank",       user_name: "ANR****", amount_btc: 0.0110000, created_at: "2025-05-17" },
  { id: 9, pet_type: "Silicon Valley Bank",       user_name: "JAC****", amount_btc: 0.008782000, created_at: "2025-05-17" },
  { id: 10, pet_type: "Bendigo Bank",       user_name: "HAR****", amount_btc: 0.00910000, created_at: "2025-05-17" },
  { id: 11, pet_type: "Citizens Bank",       user_name: "PET****", amount_btc: 0.00670000, created_at: "2025-05-17" },
  { id: 12, pet_type: "Wells Fargo & Co.",       user_name: "VER****", amount_btc: 0.005780000, created_at: "2025-05-17" },
  { id: 13, pet_type: "Silicon Valley Bank",       user_name: "GOD****", amount_btc: 0.00354710000, created_at: "2025-05-17" },
  { id: 14, pet_type: "ANZ Bank",       user_name: "JER****", amount_btc: 0.0110000, created_at: "2025-05-17" },
  { id: 15, pet_type: "Close Brothers Group plc",       user_name: "HER****", amount_btc: 0.00390000, created_at: "2025-05-17" },
  { id: 16, pet_type: "Schroders",       user_name: "MIC****", amount_btc: 0.00530000, created_at: "2025-05-17" },
  { id: 17, pet_type: "Commonwealth Bank",       user_name: "RON****", amount_btc: 0.00710000, created_at: "2025-05-17" },
  { id: 18, pet_type: "Wells Fargo & Co.",       user_name: "FRA****", amount_btc: 0.00450000, created_at: "2025-05-17" },
  { id: 19, pet_type: "Silicon Valley Bank",       user_name: "RIC****", amount_btc: 0.00370000, created_at: "2025-05-17" },
  { id: 20, pet_type: "Close Brothers Group plc",       user_name: "MEN****", amount_btc: 0.00760000, created_at: "2025-05-17" },
];

const MOCK_BTC_ADDRESS = "bc1qy3vpnmmq9wml4gwag90vqj84xw35uxgahuwglh";

// ─── FORMATTERS ───────────────────────────────────────────────────────────────


function formatDate(str) {
  return str ? str.slice(0, 10) : "";
}

// ─── API HELPERS ──────────────────────────────────────────────────────────────
async function apiFetch(path, options = {}, token = null) {
  const headers = { "Content-Type": "application/json" };
  if (token) headers["Authorization"] = `Bearer ${token}`;
  const res = await fetch(`${API}${path}`, { ...options, headers });
  const data = await res.json();
  if (!res.ok) throw new Error(data.error || "Request failed");
  return data;
}

// ─── AUTH HOOK ────────────────────────────────────────────────────────────────
function useAuth() {
  const [user,  setUser]  = useState(() => { try { return JSON.parse(localStorage.getItem("pm_user")); } catch { return null; } });
  const [token, setToken] = useState(() => localStorage.getItem("pm_token") || null);

  function persist(u, t) {
    setUser(u); setToken(t);
    localStorage.setItem("pm_user",  JSON.stringify(u));
    localStorage.setItem("pm_token", t);
  }

  const login  = async (email, password) => {
    const data = await apiFetch("/auth/login",    { method: "POST", body: JSON.stringify({ email, password }) });
    persist(data.user, data.token);
  };
  const signup = async (email, password, name) => {
    const data = await apiFetch("/auth/register", { method: "POST", body: JSON.stringify({ name, email, password }) });
    persist(data.user, data.token);
  };
  const logout = () => {
    setUser(null); setToken(null);
    localStorage.removeItem("pm_user"); localStorage.removeItem("pm_token");
  };

  return { user, token, login, signup, logout };
}

// ─── RECEIPT DOWNLOAD ─────────────────────────────────────────────────────────
function downloadReceipt(order, user) {
  const lines = [
    "===========================================",
    "         NEXVAULT — PURCHASE RECEIPT       ",
    "===========================================",
    "",
    `Order ID    : #${order.localId}`,
    `Date        : ${order.date}`,
    `Buyer       : ${user?.name || "Customer"}`,
    `Email       : ${user?.email || "—"}`,
    "",
    "-------------------------------------------",
    `Bank Log         : ${order.pet}`,
    `Description : ${order.description}`,
    `       : ${order.store}`,
    "",
    `Price Paid  : ${toUSD(order.price_btc)}`,
    `BTC Address : ${order.btcAddress}`,
    "",
    "-------------------------------------------",
    "Status      : Payment Confirmed ✓",
    "",
    "Thank you for your purchase!",
    "Support: NexVault@bluemailx.com",
    "===========================================",
  ];
  const blob = new Blob([lines.join("\n")], { type:"text/plain" });
  const url  = URL.createObjectURL(blob);
  const a    = document.createElement("a");
  a.href     = url;
  a.download = `PawMarket_Receipt_${order.localId}.txt`;
  a.click();
  URL.revokeObjectURL(url);
}



const css = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  :root {
    --bg:#0d0f14; --surface:#161922; --surface2:#1e222e; --border:#2a2f3d;
    --accent:#f7931a; --accent2:#ffb347; --text:#f0f2f7; --muted:#7a8299;
    --green:#22c55e; --red:#ef4444; --radius:12px;
  }
  body { background:var(--bg); color:var(--text); font-family:'DM Sans',sans-serif; min-height:100vh; }
  h1,h2,h3,h4 { font-family:'Syne',sans-serif; }
  .app { min-height:100vh; background:var(--bg); }

  /* ── Landing shell ── */
  .landing {
    min-height:100vh;
    display:flex;
    align-items:center;
    justify-content:center;
    position:relative;
    overflow:hidden;
    background:#010d01;
    padding:24px 16px;
  }
  .landing-bg {
    position:absolute;
    inset:0;
    width:100%;
    height:100%;
    object-fit:cover;
    z-index:0;
  }
  .landing-overlay {
    position:absolute;
    inset:0;
    background:radial-gradient(ellipse 60% 70% at 50% 50%, rgba(1,13,1,0.35) 0%, rgba(1,13,1,0.82) 100%);
    z-index:1;
  }

  /* ── Split card ── */
  .landing-card {
    display:flex;
    width:900px;
    max-width:100%;
    min-height:540px;
    position:relative;
    z-index:2;
    border-radius:22px;
    overflow:hidden;
    border:1px solid rgba(255,255,255,0.09);
    box-shadow:0 48px 120px rgba(0,0,0,.75);
  }

  /* LEFT PANEL */
  .panel-left {
    flex:0 0 42%;
    background:rgba(13,15,20,0.72);
    backdrop-filter:blur(18px);
    -webkit-backdrop-filter:blur(18px);
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    padding:44px 40px 36px;
    position:relative;
    overflow:hidden;
    border-right:1px solid rgba(255,255,255,0.07);
  }
  .panel-left::before {
    content:'';
    position:absolute;
    width:380px;
    height:380px;
    border-radius:50%;
    background:radial-gradient(circle,rgba(247,147,26,.14) 0%,transparent 65%);
    top:-100px;
    right:-100px;
    pointer-events:none;
  }
  .panel-left::after {
    content:'';
    position:absolute;
    width:220px;
    height:220px;
    border-radius:50%;
    background:radial-gradient(circle,rgba(247,147,26,.07) 0%,transparent 70%);
    bottom:-40px;
    left:-60px;
    pointer-events:none;
  }
  .brand-row {
    display:flex;
    align-items:center;
    gap:12px;
    position:relative;
    z-index:1;
  }
  .brand-icon {
    width:46px;
    height:46px;
    background:var(--accent);
    border-radius:13px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:22px;
    flex-shrink:0;
    box-shadow:0 8px 24px rgba(247,147,26,.3);
  }
  .brand-name {
    font-family:'Syne',sans-serif;
    font-size:22px;
    font-weight:800;
    color:var(--accent);
    letter-spacing:-.3px;
  }
  .tagline {
    position:relative;
    z-index:1;
    margin-top:auto;
    padding-top:32px;
  }
  .tagline-headline {
    font-family:'Syne',sans-serif;
    font-size:30px;
    font-weight:800;
    color:var(--text);
    line-height:1.2;
    margin-bottom:14px;
    letter-spacing:-.5px;
  }
  .tagline-headline span { color:var(--accent); }
  .tagline-body {
    font-size:13px;
    color:var(--muted);
    line-height:1.75;
    font-weight:300;
  }
  .trust-row {
    display:flex;
    flex-direction:column;
    gap:9px;
    margin-top:28px;
    position:relative;
    z-index:1;
  }
  .trust-item {
    display:flex;
    align-items:center;
    gap:9px;
    font-size:12px;
    color:var(--muted);
  }
  .trust-dot {
    width:6px;
    height:6px;
    border-radius:50%;
    background:var(--accent);
    flex-shrink:0;
  }

  /* RIGHT PANEL */
  .panel-right {
    flex:1;
    background:rgba(10,12,17,0.82);
    backdrop-filter:blur(18px);
    -webkit-backdrop-filter:blur(18px);
    display:flex;
    flex-direction:column;
    justify-content:center;
    padding:48px 44px;
  }
  .panel-title {
    font-family:'Syne',sans-serif;
    font-size:22px;
    font-weight:800;
    color:var(--text);
    margin-bottom:6px;
    letter-spacing:-.3px;
  }
  .panel-sub {
    font-size:13px;
    color:var(--muted);
    margin-bottom:28px;
  }

  /* existing tab/form/button classes kept as-is */
  .auth-tabs { display:flex; gap:4px; background:var(--surface2); border-radius:10px; padding:4px; margin-bottom:28px; }
  .auth-tab { flex:1; padding:9px; border:none; background:transparent; color:var(--muted); font-family:'DM Sans',sans-serif; font-size:14px; font-weight:500; border-radius:8px; cursor:pointer; transition:all .2s; }
  .auth-tab.active { background:var(--accent); color:#000; font-weight:700; }
  .form-group { margin-bottom:16px; }
  .form-label { display:block; font-size:12px; font-weight:500; color:var(--muted); margin-bottom:6px; letter-spacing:.5px; text-transform:uppercase; }
  .form-input { width:100%; padding:12px 14px; background:rgba(30,34,46,0.8); border:1px solid var(--border); border-radius:10px; color:var(--text); font-family:'DM Sans',sans-serif; font-size:15px; outline:none; transition:border-color .2s; }
  .form-input:focus { border-color:var(--accent); }
  .form-input::placeholder { color:var(--muted); }
  .btn-primary { width:100%; padding:13px; background:var(--accent); color:#000; border:none; border-radius:10px; font-family:'Syne',sans-serif; font-size:15px; font-weight:700; cursor:pointer; transition:all .2s; margin-top:8px; }
  .btn-primary:hover { background:var(--accent2); transform:translateY(-1px); }
  .btn-primary:disabled { opacity:.6; cursor:not-allowed; transform:none; }
  .error-msg { color:var(--red); font-size:13px; margin-top:10px; text-align:center; }

  /* Divider + BTC badge */
  .divider-line {
    display:flex;
    align-items:center;
    gap:10px;
    margin:18px 0 12px;
  }
  .divider-line::before,.divider-line::after {
    content:'';
    flex:1;
    height:1px;
    background:var(--border);
  }
  .divider-line span {
    font-size:10px;
    color:var(--muted);
    letter-spacing:.8px;
    text-transform:uppercase;
    white-space:nowrap;
  }
  .btc-badge-row {
    display:flex;
    align-items:center;
    justify-content:center;
    gap:8px;
    font-size:12px;
    color:var(--muted);
  }
  .btc-dot {
    width:8px;
    height:8px;
    border-radius:50%;
    background:var(--accent);
    animation:pulse 2s infinite;
    flex-shrink:0;
  }

  /* ── Layout ── */
  .main-layout { display:flex; min-height:100vh; flex-direction:column; }
  .topbar { height:60px; background:var(--surface); border-bottom:1px solid var(--border); display:flex; align-items:center; padding:0 20px; gap:12px; position:sticky; top:0; z-index:100; }
  .topbar-logo { font-family:'Syne',sans-serif; font-weight:800; color:var(--accent); font-size:18px; margin-left:8px; }
  .topbar-right { margin-left:auto; display:flex; align-items:center; gap:12px; }
  .btc-badge { display:flex; align-items:center; gap:6px; background:rgba(247,147,26,.1); border:1px solid rgba(247,147,26,.25); border-radius:20px; padding:5px 12px; font-size:12px; color:var(--accent); font-weight:600; }

  /* Sidebar */
  .sidebar-overlay { position:fixed; inset:0; background:rgba(0,0,0,.6); z-index:200; backdrop-filter:blur(2px); }
  .sidebar { position:fixed; top:0; left:0; bottom:0; width:280px; background:var(--surface); border-right:1px solid var(--border); z-index:201; display:flex; flex-direction:column; transform:translateX(-100%); transition:transform .3s cubic-bezier(.4,0,.2,1); }
  .sidebar.open { transform:translateX(0); }
  .sidebar-header { padding:20px; border-bottom:1px solid var(--border); display:flex; align-items:center; justify-content:space-between; }
  .sidebar-user { display:flex; align-items:center; gap:10px; }
  .avatar { width:38px; height:38px; background:var(--accent); border-radius:50%; display:flex; align-items:center; justify-content:center; font-family:'Syne',sans-serif; font-weight:700; color:#000; font-size:14px; flex-shrink:0; }
  .sidebar-username { font-weight:600; font-size:15px; display:flex; align-items:center; gap:6px; }
  .sidebar-dropdown-btn { background:none; border:none; color:var(--muted); cursor:pointer; display:flex; align-items:center; padding:2px; transition:transform .2s; }
  .sidebar-dropdown-btn.open { transform:rotate(180deg); }
  .user-detail-panel { padding:12px 20px; background:var(--surface2); border-bottom:1px solid var(--border); font-size:13px; color:var(--muted); }
  .user-detail-panel span { display:block; margin-bottom:4px; }
  .sidebar-nav { flex:1; padding:12px 0; overflow-y:auto; }
  .sidebar-item { display:flex; align-items:center; gap:12px; padding:13px 20px; cursor:pointer; color:var(--muted); font-size:14px; font-weight:500; transition:all .15s; border-left:3px solid transparent; }
  .sidebar-item:hover { color:var(--text); background:var(--surface2); border-left-color:var(--accent); }
  .sidebar-item.danger { color:var(--red); }
  .sidebar-item.danger:hover { background:rgba(239,68,68,.08); border-left-color:var(--red); }

  /* Page */
  .page { flex:1; padding:28px 24px; max-width:1100px; margin:0 auto; width:100%; }
  .page-title { font-size:26px; font-weight:800; margin-bottom:6px; }
  .page-sub { color:var(--muted); font-size:14px; margin-bottom:28px; }

  /* Table */
  .table-wrap { background:var(--surface); border:1px solid var(--border); border-radius:var(--radius); overflow:hidden; }
  table { width:100%; border-collapse:collapse; }
  thead { background:var(--surface2); }
  th { padding:13px 16px; text-align:left; font-size:11px; font-weight:700; color:var(--muted); text-transform:uppercase; letter-spacing:.8px; }
  td { padding:14px 16px; font-size:14px; border-top:1px solid var(--border); }
  tr:hover td { background:rgba(255,255,255,.02); }
  .user-chip { display:inline-flex; align-items:center; gap:6px; background:var(--surface2); border-radius:20px; padding:3px 10px; font-size:13px; font-weight:500; }
  .price-usd { color:var(--green); font-weight:700; font-family:'Syne',sans-serif; }
  .price-btc-sub { color:var(--muted); font-size:11px; font-family:monospace; margin-top:2px; }
  .date-cell { color:var(--muted); font-size:13px; }
  .stock-cell { font-weight:600; }
  .stock-low { color:var(--red); }
  .stock-ok { color:var(--green); }

  /* Stores */
  .stores-section { margin-top:36px; }
  .section-label { font-size:11px; font-weight:700; color:var(--muted); text-transform:uppercase; letter-spacing:1px; margin-bottom:14px; }
  .store-card { background:var(--surface); border:1px solid var(--border); border-radius:var(--radius); margin-bottom:10px; overflow:hidden; transition:border-color .2s; }
  .store-card:hover { border-color:rgba(247,147,26,.3); }
  .store-header { display:flex; align-items:center; justify-content:space-between; padding:16px 20px; cursor:pointer; }
  .store-header-left { display:flex; align-items:center; gap:14px; }
  .store-emoji { font-size:26px; }
  .store-name { font-family:'Syne',sans-serif; font-weight:700; font-size:16px; }
  .store-type { font-size:12px; color:var(--muted); margin-top:2px; }
  .chevron { color:var(--muted); transition:transform .25s; }
  .chevron.open { transform:rotate(90deg); }
  .pet-types { padding:12px 20px 16px; background:var(--surface2); display:flex; flex-wrap:wrap; gap:10px; }
  .pet-type-btn { padding:8px 18px; background:var(--surface); border:1px solid var(--border); border-radius:20px; color:var(--text); font-size:13px; font-weight:500; cursor:pointer; transition:all .15s; font-family:'DM Sans',sans-serif; }
  .pet-type-btn:hover { background:var(--accent); color:#000; border-color:var(--accent); font-weight:700; }

  /* Breed screen */
  .back-btn { display:inline-flex; align-items:center; gap:8px; color:var(--muted); font-size:14px; cursor:pointer; margin-bottom:20px; padding:6px 0; transition:color .15s; background:none; border:none; font-family:'DM Sans',sans-serif; }
  .back-btn:hover { color:var(--text); }
  .buy-btn { padding:7px 18px; background:var(--accent); color:#000; border:none; border-radius:8px; font-family:'Syne',sans-serif; font-size:13px; font-weight:700; cursor:pointer; transition:all .15s; }
  .buy-btn:hover { background:var(--accent2); transform:translateY(-1px); }
  .buy-btn:disabled { opacity:.4; cursor:not-allowed; transform:none; }

  /* BTC payment */
  .btc-screen { max-width:520px; margin:0 auto; }
  .btc-card { background:var(--surface); border:1px solid var(--border); border-radius:16px; padding:36px; text-align:center; }
  .btc-title { font-size:22px; font-weight:800; margin-bottom:6px; }
  .btc-subtitle { color:var(--muted); font-size:14px; margin-bottom:24px; }
  .amount-block { background:var(--surface2); border:1px solid var(--border); border-radius:12px; padding:16px 20px; margin-bottom:24px; }
  .amount-usd { font-size:32px; font-weight:800; color:var(--green); font-family:'Syne',sans-serif; }
  .qr-box { width:180px; height:180px; background:#fff; border-radius:12px; margin:0 auto 20px; display:flex; align-items:center; justify-content:center; overflow:hidden; }
  .address-label { font-size:11px; color:var(--muted); text-transform:uppercase; letter-spacing:.6px; margin-bottom:6px; text-align:left; }
  .address-row { display:flex; align-items:center; gap:8px; background:var(--surface2); border:1px solid var(--border); border-radius:10px; padding:12px 14px; margin-bottom:20px; text-align:left; }
  .address-text { flex:1; font-size:12px; color:var(--muted); font-family:monospace; word-break:break-all; line-height:1.5; }
  .copy-btn { background:none; border:none; color:var(--muted); cursor:pointer; padding:4px; transition:color .15s; flex-shrink:0; }
  .copy-btn:hover { color:var(--accent); }
  .timer-row { display:flex; align-items:center; justify-content:center; gap:8px; color:var(--muted); font-size:14px; margin-bottom:20px; }
  .timer-num { font-family:'Syne',sans-serif; font-weight:700; font-size:18px; color:var(--accent); min-width:52px; text-align:center; }
  .timer-warn { color:var(--red); }
  .status-badge { display:inline-flex; align-items:center; gap:8px; padding:10px 20px; border-radius:20px; font-size:14px; font-weight:600; }
  .status-waiting { background:rgba(247,147,26,.1); color:var(--accent); border:1px solid rgba(247,147,26,.25); }
  .status-paid { background:rgba(34,197,94,.1); color:var(--green); border:1px solid rgba(34,197,94,.25); }

  /* BTC warning banner */
  .btc-warning-banner { background:rgba(239,68,68,.08); border:1px solid rgba(239,68,68,.3); border-radius:10px; padding:12px 16px; margin-bottom:20px; text-align:left; }
  .btc-warning-title { font-family:'Syne',sans-serif; font-weight:700; font-size:14px; color:var(--text); margin-bottom:4px; }
  .btc-warning-sub { font-size:12px; color:var(--muted); margin-bottom:6px; }
  .btc-warning-red { font-size:13px; font-weight:600; color:var(--red); }

  /* Discount box */
  .discount-row { display:flex; gap:8px; margin-bottom:20px; text-align:left; }
  .discount-input { flex:1; padding:10px 14px; background:var(--surface2); border:1px solid var(--border); border-radius:8px; color:var(--text); font-family:'DM Sans',sans-serif; font-size:14px; outline:none; transition:border-color .2s; }
  .discount-input:focus { border-color:var(--accent); }
  .discount-input::placeholder { color:var(--muted); }
  .discount-btn { padding:10px 16px; background:var(--accent); color:#000; border:none; border-radius:8px; font-family:'Syne',sans-serif; font-size:13px; font-weight:700; cursor:pointer; transition:all .15s; white-space:nowrap; }
  .discount-btn:hover { background:var(--accent2); }
  .discount-btn:disabled { opacity:.5; cursor:not-allowed; }
  .discount-success { font-size:12px; color:var(--green); margin-top:-14px; margin-bottom:14px; display:flex; align-items:center; gap:4px; text-align:left; }
  .discount-error { font-size:12px; color:var(--red); margin-top:-14px; margin-bottom:14px; text-align:left; }

  /* Misc */
  .spinner { display:inline-block; width:20px; height:20px; border:2px solid var(--border); border-top-color:var(--accent); border-radius:50%; animation:spin .7s linear infinite; }
  @keyframes spin { to { transform:rotate(360deg); } }
  .loading-row { display:flex; align-items:center; justify-content:center; gap:10px; padding:40px; color:var(--muted); }
  @keyframes fadeUp { from{opacity:0;transform:translateY(16px);}to{opacity:1;transform:translateY(0);} }
  .fade-up { animation:fadeUp .35s ease both; }
  @keyframes pulse { 0%,100%{opacity:1;}50%{opacity:.5;} }
  .pulse { animation:pulse 1.5s infinite; }

  /* Responsive */
  @media(max-width:720px){
    .landing-card { flex-direction:column; border-radius:16px; min-height:unset; }
    .panel-left { flex:none; padding:32px 28px 28px; border-right:none; border-bottom:1px solid rgba(255,255,255,0.07); }
    .panel-left::before { width:240px; height:240px; top:-60px; right:-60px; }
    .tagline-headline { font-size:22px; }
    .trust-row { display:none; }
    .panel-right { padding:32px 28px 36px; }
  }
  @media(max-width:420px){
    .panel-left { padding:24px 20px 22px; }
    .panel-right { padding:24px 20px 30px; }
    .tagline-headline { font-size:19px; }
    .page { padding:20px 14px; }
    th,td { padding:10px; }
  }


  @media (max-width: 768px) {
  /* ── Horizontal scroll for all tables ── */
  .table-wrap {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    border-radius: 10px;
  }

  /* Force a readable minimum width so columns never overlap */
  .table-wrap table {
    width: 100% !important;
    min-width: 640px;
    table-layout: auto !important;   /* overrides inline fixed layout */
  }

  .table-wrap th,
  .table-wrap td {
    padding: 10px 12px;
    vertical-align: middle;
    font-size: 13px;
  }

  /* Column 1: Bank Log name */
  .table-wrap th:nth-child(1),
  .table-wrap td:nth-child(1) {
    min-width: 130px;
    white-space: nowrap;
  }

  /* Column 2: Description — allow wrap, give it room */
  .table-wrap th:nth-child(2),
  .table-wrap td:nth-child(2) {
    white-space: normal !important;
    min-width: 200px;
    max-width: 260px;
    word-break: break-word !important;
    line-height: 1.4;
  }

  /* Columns 3 & 4: Price & Balance */
  .table-wrap th:nth-child(3),
  .table-wrap td:nth-child(3),
  .table-wrap th:nth-child(4),
  .table-wrap td:nth-child(4) {
    min-width: 110px;
    text-align: right;
    white-space: nowrap;
  }

  /* Column 5: Buy button */
  .table-wrap th:nth-child(5),
  .table-wrap td:nth-child(5) {
    min-width: 90px;
    text-align: center;
    white-space: nowrap;
  }

  /* Buy button sizing */
  .buy-btn {
    padding: 6px 14px;
    font-size: 12px;
  }

  /* Tighten page padding */
  .page {
    padding: 16px 12px !important;
  }
  .page-title {
    font-size: 20px !important;
  }
  .page-sub {
    font-size: 13px !important;
    margin-bottom: 16px !important;
  }
  .back-btn {
    margin-bottom: 14px;
    font-size: 13px;
  }
}

@media (max-width: 420px) {
  .table-wrap table {
    min-width: 580px;
  }
  .table-wrap th,
  .table-wrap td {
    padding: 8px 10px;
    font-size: 12px;
  }
  .table-wrap th:nth-child(2),
  .table-wrap td:nth-child(2) {
    min-width: 170px;
  }
}
`;

// ─── QR CODE (real, scannable) ───────────────────────────────────────────────
function QRDisplay({ address, amountBtc }) {
  const canvasRef = useRef(null);
  // bitcoin: URI is the standard that all wallet apps recognise
  const uri = address;

  useEffect(() => {
    if (!canvasRef.current) return;
    QRCode.toCanvas(canvasRef.current, uri, {
      width: 168,
      margin: 1,
      color: { dark: "#000000", light: "#ffffff" },
      errorCorrectionLevel: "M",
    }, (err) => { if (err) console.error("QR error:", err); });
  }, [uri]);

  return <canvas ref={canvasRef} style={{ borderRadius: 8 }} />;
}

// ─── PAYMENT SCREEN ─────────────────────────────────────────────────────────────
function BTCPayment({ item, store, token, onBack, onPaid, onGoToPets }) {
  const [copied,        setCopied]        = useState(false);
  const [seconds,       setSeconds]       = useState(1800);
  const [paid,          setPaid]          = useState(false);
  const [orderId,       setOrderId]       = useState(null);
  const [btcAddress,    setBtcAddress]    = useState(MOCK_BTC_ADDRESS);
  const [creating,      setCreating]      = useState(true);
  const [discountCode,  setDiscountCode]  = useState("");
  const [discountState, setDiscountState] = useState("idle");
  const [discountMsg,   setDiscountMsg]   = useState("");
  const [finalPriceBtc, setFinalPriceBtc] = useState(item.price_btc);

  const usdPrice = toUSD(finalPriceBtc);
  const emoji    = EMOJI_MAP[store.emoji] || "🐾";

  useEffect(() => {
    async function createOrder() {
      try {
        const orderRes   = await apiFetch("/orders", { method:"POST", body:JSON.stringify({ breed_id:item.id, amount_btc: item.price_btc, item_name: item.pet }) }, token);
        setOrderId(orderRes.order.id);
        const invoiceRes = await apiFetch("/payments/create-invoice", { method:"POST", body:JSON.stringify({ order_id:orderRes.order.id }) }, token);
        setBtcAddress(invoiceRes.btc_address);
      } catch(e) { console.warn("Invoice:", e.message); }
      finally { setCreating(false); }
    }
    createOrder();
  }, []);

  useEffect(() => {
    if (paid) return;
    const t = setInterval(()=>setSeconds(s=>s>0?s-1:0),1000);
    return ()=>clearInterval(t);
  }, [paid]);

  useEffect(() => {
  if (!orderId || paid) return;

  const iv = setInterval(async () => {
    try {
      const d = await apiFetch(`/payments/status/${orderId}`, {}, token);
      if (d.status === "confirmed") {
        clearInterval(iv);
        // Build order object here, don't rely on stale closure via handleConfirm
        const newOrder = {
          localId: Date.now(),
          pet: item.pet || item.breed,
          description: item.description,
          store: store.name,
          price_btc: item.price_btc,
          btcAddress: btcAddress,
          date: new Date().toISOString().slice(0, 10),
          status: "confirmed",
        };
        onPaid(newOrder);
        setPaid(true); // trigger re-render AFTER onPaid
      }
    } catch (e) {
      console.error("Poll error:", e);
    }
  }, 10000);

  return () => clearInterval(iv);
}, [orderId, paid, btcAddress]); // add btcAddress as dependency
  const mins = String(Math.floor(seconds/60)).padStart(2,"0");
  const secs = String(seconds%60).padStart(2,"0");

  function copy(){ navigator.clipboard.writeText(btcAddress).catch(()=>{}); setCopied(true); setTimeout(()=>setCopied(false),2000); }

  async function applyDiscount() {
    if (!discountCode.trim()) return;
    setDiscountState("loading");
    setDiscountMsg("");
    try {
      const res = await apiFetch("/payments/discount", { method:"POST", body:JSON.stringify({ code:discountCode, breed_id:item.id }) }, token);
      setFinalPriceBtc(res.discounted_price_btc);
      setDiscountMsg(`Code applied! You saved ${toUSD(item.price_btc - res.discounted_price_btc)}`);
      setDiscountState("success");
    } catch(e) {
      setDiscountMsg(e.message || "Invalid discount code");
      setDiscountState("error");
    }
  }

  return (
    <div className="page fade-up" style={{maxWidth:"100%",padding:"28px 24px"}}>
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>

      {/* ── Two-column layout on large screens, single column on mobile ── */}
      <div style={{
        display:"grid",
        gridTemplateColumns:"1fr 1fr",
        gap:24,
        maxWidth:1000,
        margin:"0 auto",
        alignItems:"start",
      }} className="btc-grid">

        {/* LEFT: Summary + QR */}
        <div className="btc-card" style={{padding:"32px 28px",textAlign:"center"}}>
          <div style={{fontSize:44,marginBottom:10}}>{emoji}</div>
          <div className="btc-title" style={{fontSize:20,marginBottom:4}}>Complete Payment</div>
          <div className="btc-subtitle" style={{marginBottom:20}}>{store.name}</div>

          <div className="amount-block" style={{marginBottom:20}}>
            <div style={{fontSize:11,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".6px",marginBottom:6}}>Total Due</div>
            <div className="amount-usd">{usdPrice}</div>
            {discountState==="success" && (
              <div style={{fontSize:12,color:"var(--muted)",marginTop:4,textDecoration:"line-through"}}>{toUSD(item.price_btc)}</div>
            )}
          </div>

          {creating ? (
            <div className="loading-row"><span className="spinner"/> Generating address…</div>
          ) : !paid ? (
            <>
              <div className="btc-warning-banner" style={{textAlign:"left",marginBottom:16}}>
                <div className="btc-warning-title">Buy using BTC</div>
                <div className="btc-warning-sub">Send only BTC to this address</div>
                <div className="btc-warning-red">Sending coins or tokens other than BTC will result in the loss of funds.</div>
              </div>

              <div className="qr-box" style={{width:160,height:160,margin:"0 auto 16px"}}>
                <QRDisplay address={btcAddress} amountBtc={finalPriceBtc}/>
              </div>

              <div className="timer-row" style={{marginBottom:16}}>
                <Clock size={15}/>
                <span>Expires in</span>
                <span className={`timer-num ${seconds<120?"timer-warn":""}`}>{mins}:{secs}</span>
              </div>

              <div className="status-badge status-waiting pulse" style={{margin:"0 auto"}}>
                <span style={{width:8,height:8,borderRadius:"50%",background:"var(--accent)",display:"inline-block"}}/>
                Awaiting payment…
              </div>
              <div style={{marginTop:8,fontSize:12,color:"var(--muted)"}}>⚡ Lightning Network accepted</div>
            </>
          ) : (
            <div style={{marginTop:8}}>
              <div style={{fontSize:56,marginBottom:10}}>🎉</div>
              <div className="status-badge status-paid" style={{margin:"0 auto 14px"}}><Check size={16}/> Payment Confirmed!</div>
              <div style={{color:"var(--muted)",fontSize:13,marginBottom:16}}>
                Received on: {new Date().toLocaleString()}
              </div>
              <button className="btn-primary" style={{maxWidth:200,margin:"0 auto"}} onClick={onGoToPets}>
                View Transaction Details
              </button>
            </div>
          )}
        </div>

        {/* RIGHT: Address + Discount + Actions */}
        {!paid && !creating && (
          <div style={{display:"flex",flexDirection:"column",gap:16}}>

            {/* Address card */}
            <div className="btc-card" style={{padding:"24px 24px",textAlign:"left"}}>
              <div className="address-label" style={{marginBottom:8}}>Bitcoin Address</div>
              <div className="address-row" style={{marginBottom:0}}>
                <span className="address-text">{btcAddress}</span>
                <button className="copy-btn" onClick={copy}>
                  {copied ? <Check size={16} color="var(--green)"/> : <Copy size={16}/>}
                </button>
              </div>
              {copied && (
                <div style={{fontSize:12,color:"var(--green)",marginTop:8,display:"flex",alignItems:"center",gap:4}}>
                  <Check size={12}/> Address copied!
                </div>
              )}
            </div>

            {/* Discount card */}
            <div className="btc-card" style={{padding:"24px 24px",textAlign:"left"}}>
              <div className="address-label" style={{marginBottom:10}}>Discount Code</div>
              <div style={{display:"flex",gap:8,marginBottom: discountMsg ? 10 : 0}}>
                <input
                  style={{
                    flex:1,
                    padding:"11px 14px",
                    background:"var(--surface2)",
                    border:`1px solid ${discountState==="success"?"var(--green)":discountState==="error"?"var(--red)":"var(--border)"}`,
                    borderRadius:10,
                    color:"var(--text)",
                    fontFamily:"'DM Sans',sans-serif",
                    fontSize:14,
                    outline:"none",
                    transition:"border-color .2s",
                  }}
                  placeholder="Enter discount code"
                  value={discountCode}
                  onChange={e=>{setDiscountCode(e.target.value);setDiscountState("idle");setDiscountMsg("");}}
                  disabled={discountState==="success"}
                />
                <button
                  onClick={applyDiscount}
                  disabled={discountState==="loading"||discountState==="success"||!discountCode.trim()}
                  style={{
                    padding:"11px 20px",
                    background: discountState==="success" ? "var(--green)" : "linear-gradient(135deg,#f7931a,#ffb347)",
                    color:"#000",
                    border:"none",
                    borderRadius:10,
                    fontFamily:"'Syne',sans-serif",
                    fontWeight:800,
                    fontSize:13,
                    cursor: discountState==="loading"||discountState==="success"||!discountCode.trim() ? "not-allowed" : "pointer",
                    opacity: discountState==="loading"||(!discountCode.trim()&&discountState!=="success") ? 0.6 : 1,
                    boxShadow: discountState==="success" ? "0 4px 14px rgba(34,197,94,.3)" : "0 4px 14px rgba(247,147,26,.35)",
                    transition:"all .2s",
                    whiteSpace:"nowrap",
                    display:"flex",
                    alignItems:"center",
                    gap:6,
                  }}
                >
                  {discountState==="loading" ? "…" : discountState==="success" ? <><Check size={14}/> Applied!</> : "Apply"}
                </button>
              </div>
              {discountState==="success" && (
                <div style={{display:"flex",alignItems:"center",gap:6,color:"var(--green)",fontSize:13,fontWeight:600,marginTop:0}}>
                  <Check size={13}/> {discountMsg}
                </div>
              )}
              {discountState==="error" && (
                <div style={{color:"var(--red)",fontSize:13,fontWeight:600}}>
                  ✕ {discountMsg}
                </div>
              )}
            </div>

            
          </div>
        )}

        {/* Right side placeholder when paid or creating */}
        {(paid || creating) && <div/>}
      </div>

      {/* Responsive: collapse to single col on mobile */}
      <style>{`
        @media(max-width:700px){
          .btc-grid{ grid-template-columns:1fr !important; max-width:480px !important; }
        }
      `}</style>
    </div>
  );
}

function AnimalScreen({ animal, store, onBack, onBuy }) {
  return (
    <div className="page fade-up">
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>

      <div style={{display:"flex",alignItems:"center",gap:16,marginBottom:28}}>
        <span style={{fontSize:52}}>{animal.emoji}</span>
        <div>
          <div className="page-title" style={{marginBottom:4}}>{animal.pet}</div>
          <div style={{color:"var(--muted)",fontSize:14}}>{store.name}</div>
        </div>
      </div>

      <div className="table-wrap">
        <table style={{tableLayout:"fixed",width:"100%"}}>
          <colgroup>
            <col style={{width:"22%"}}/>
            <col style={{width:"32%"}}/>
            <col style={{width:"16%"}}/>
            <col style={{width:"16%"}}/>
            <col style={{width:"14%"}}/>
          </colgroup>
          <thead>
            <tr>
              <th>Bank Logs</th>
              <th>Description</th>
              <th>Price (USD)</th>
              <th>Balance</th>
              <th>Order</th>
            </tr>
          </thead>
          <tbody>
            {(ANIMAL_VARIATIONS[animal.pet]||[]).map(v=>(
              <tr key={v.id}>
                <td>
                  <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                    <span style={{fontSize:18,flexShrink:0}}>{v.emoji}</span>
                    <strong style={{wordBreak:"break-word"}}>{v.pet}</strong>
                  </div>
                </td>
                <td style={{color:"var(--muted)",fontSize:13,lineHeight:1.5,wordBreak:"break-word"}}>{v.description}</td>
                <td><strong style={{color:"var(--green)",fontFamily:"'DM Sans',sans-serif",fontWeight:700,whiteSpace:"nowrap"}}>{toUSD(v.price_btc)}</strong></td>
                <td className="stock-cell stock-ok" style={{whiteSpace:"nowrap"}}>${v.stock}</td>
                <td><button className="buy-btn" onClick={()=>onBuy(v)}>Buy</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <style>{`
        @media(max-width:640px){
          .animal-table th:nth-child(2),
          .animal-table td:nth-child(2){ display:none; }
        }
      `}</style>
    </div>
  );
}


// ─── VARIATION SCREEN ────────────────────────────────────────────────────────
// Shows different styled editions of the same animal for a given store
function BreedScreen({ store, onBack, onBuy }) {
  const emoji      = EMOJI_MAP[store.emoji] || "🏦";
  const animals = STORE_ANIMALS[store.emoji] || [];

  return (
    <div className="page fade-up">
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>
      <div style={{display:"flex",alignItems:"center",gap:14,marginBottom:24}}>
        <span style={{fontSize:36}}>{emoji}</span>
        <div>
          <div className="page-title" style={{marginBottom:0}}>{store.name}</div>
          <div style={{color:"var(--muted)",fontSize:14}}>{store.pet_type}</div>
        </div>
      </div>
      <div className="table-wrap">
        <table>
          <thead>
            <tr>
              <th>Bank Logs</th>
              <th>Description</th>
              <th>Price (USD)</th>
              <th>Balance</th>
              <th>Order</th>
            </tr>
          </thead>
          <tbody>
            {animals.map(v=>(
              <tr key={v.id}>
                <td><strong>{v.pet}</strong></td>
                <td style={{color:"var(--muted)",maxWidth:260}}>{v.description}</td>
                <td><div className="price-usd">{toUSD(v.price_btc)}</div></td>
                <td className={`stock-cell ${v.stock<=3?"stock-low":"stock-ok"}`}>
                  {v.stock<=3?`⚠ ${v.stock} left`:v.stock}
                </td>
                <td>
                  <button className="buy-btn" onClick={()=>onBuy(v)}>Buy</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

// ─── SIDEBAR ──────────────────────────────────────────────────────────────────
function Sidebar({ open, onClose, user, onLogout, onNav, onSelectStore, onSelectAnimal, stores, localOrders }) {
  const [showUserInfo, setShowUserInfo] = useState(false);
  const [openStoreId,  setOpenStoreId]  = useState(null);

  return (
    <>
      {open && <div className="sidebar-overlay" onClick={onClose}/>}
      <div className={`sidebar ${open?"open":""}`}>
        <div className="sidebar-header">
          <div className="sidebar-user">
            <div className="avatar">{user?.name?.[0]||"U"}</div>
            <div>
              <div className="sidebar-username">
                {user?.name||"User"}
                <button className={`sidebar-dropdown-btn ${showUserInfo?"open":""}`} onClick={()=>setShowUserInfo(v=>!v)}>
                  <ChevronDown size={15}/>
                </button>
              </div>
            </div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"var(--muted)",cursor:"pointer",padding:4}}><X size={18}/></button>
        </div>

        {showUserInfo && (
          <div className="user-detail-panel">
            <span>👤 <strong>Name:</strong> {user?.name}</span>
            <span>🆔 <strong>ID:</strong> #{user?.id}</span>
          </div>
        )}

        <nav className="sidebar-nav">
          <div className="sidebar-item" onClick={()=>{onNav("account");onClose();}}><User size={16}/> Account Info</div>
          <div className="sidebar-item" onClick={()=>{onNav("mypets");onClose();}}><LandmarkIcon size={16}/> My Banks</div>
          <div className="sidebar-item" onClick={()=>{onNav("terms");onClose();}}><FileText size={16}/> Terms &amp; Policies</div>
           <div style={{margin:"8px 12px",background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:10,padding:"12px 14px"}}>
            <div style={{fontSize:11,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".6px",marginBottom:6}}>Total Payments</div>
            <div style={{fontFamily:"'Syne',sans-serif",fontWeight:800,fontSize:20,color:"var(--green)"}}>
              {localOrders.length===0?"$0.00":("$"+(localOrders.reduce((s,o)=>s+parseFloat(o.price_btc)*73123,0)).toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2}))}
            </div>
            <div style={{fontSize:12,color:"var(--muted)",marginTop:4}}>{localOrders.length} order{localOrders.length!==1?"s":""} confirmed</div>
          </div>

          <div style={{padding:"10px 20px 4px",fontSize:10,fontWeight:700,color:"var(--muted)",textTransform:"uppercase",letterSpacing:"0.8px",marginTop:6,borderTop:"1px solid var(--border)"}}>
            Banks
          </div>

          {stores.map(store=>(
            <div key={store.id}>
              <div className="sidebar-item" style={{justifyContent:"space-between"}} onClick={()=>setOpenStoreId(p=>p===store.id?null:store.id)}>
                <span style={{display:"flex",alignItems:"center",gap:10}}>
                  <span style={{fontSize:18}}>{EMOJI_MAP[store.emoji]||"🏦"}</span> {store.name}
                </span>
                <ChevronDown size={14} style={{transition:"transform .2s",transform:openStoreId===store.id?"rotate(180deg)":"none",flexShrink:0}}/>
              </div>
              {openStoreId===store.id && (
                <div style={{background:"var(--surface2)",paddingBottom:6}}>
                 {(STORE_ANIMALS[store.emoji]||[]).map(animal=>(
  <div key={animal.id}
    style={{padding:"9px 20px 9px 48px",fontSize:13,color:"var(--muted)",cursor:"pointer",transition:"color .15s",display:"flex",alignItems:"center",gap:8}}
    onMouseEnter={e=>e.currentTarget.style.color="var(--accent)"}
    onMouseLeave={e=>e.currentTarget.style.color="var(--muted)"}
    onClick={()=>{onSelectAnimal(animal,store);onClose();}}>
    <span>{animal.emoji}</span> {animal.pet}
  </div>
))}
                </div>
              )}
            </div>
          ))}

          <div style={{borderTop:"1px solid var(--border)",marginTop:6}}>
            <div className="sidebar-item danger" onClick={()=>{onLogout();onClose();}}><LogOut size={16}/> Sign Out</div>
          </div>
        </nav>

        <div style={{padding:"14px 20px",borderTop:"1px solid var(--border)",fontSize:12,color:"var(--muted)"}}>
          <div style={{display:"flex",alignItems:"center",gap:6}}>
            <Bitcoin size={13} color="var(--accent)"/> NexVault
          </div>
        </div>
      </div>
    </>
  );
}

// ─── INFO PAGES ───────────────────────────────────────────────────────────────
function AccountPage({ user, onBack }) {
  return (
    <div className="page fade-up" style={{maxWidth:500}}>
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>
      <div className="page-title">Account Info</div>
      <div className="page-sub">Your profile details</div>
      <div className="table-wrap">
        <table><tbody>
          {[["Full Name",user?.name],["User ID", user?.id],["Member Since","2026"]].map(([k,v])=>(
            <tr key={k}><td style={{color:"var(--muted)",width:140}}>{k}</td><td><strong>{v}</strong></td></tr>
          ))}
        </tbody></table>
      </div>
    </div>
  );
}

// ─── HISTORY PAGE — with receipt download ─────────────────────────────────────
function HistoryPage({ token, user, localOrders, onBack }) {
  const [apiOrders, setApiOrders] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState("");

  useEffect(()=>{
    apiFetch("/orders",{},token)
      .then(d=>setApiOrders(d.orders))
      .catch(e=>setError(e.message))
      .finally(()=>setLoading(false));
  },[token]);

  return (
    <div className="page fade-up">
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>
      <div className="page-title">Transaction History</div>
      <div className="page-sub">Your personal order history</div>
      {loading && <div className="loading-row"><span className="spinner"/> Loading…</div>}
      {error   && <div className="error-msg">{error}</div>}
      {!loading && !error && (
        <div className="table-wrap">
          <table>
            <thead><tr><th>Pet</th><th>Store</th><th>Price (USD)</th><th>Date</th><th>Status</th></tr></thead>
            <tbody>
              {localOrders.map(o=>(
                <tr key={o.localId}>
                  <td><strong>{o.pet}</strong></td>
                  <td style={{color:"var(--muted)"}}>{o.store}</td>
                  <td className="price-usd">{toUSD(o.price_btc)}</td>
                  <td className="date-cell">{o.date}</td>
                  <td><span style={{color:"var(--green)",fontSize:13,fontWeight:600}}>✓ Paid</span></td>
                </tr>
              ))}
              {apiOrders.map(o=>(
                <tr key={o.id}>
                  <td><strong>{o.breed}</strong></td>
                  <td style={{color:"var(--muted)"}}>{o.store_name}</td>
                  <td className="price-usd">{toUSD(o.amount_btc)}</td>
                  <td className="date-cell">{formatDate(o.created_at)}</td>
                  <td><span style={{color:o.status==="confirmed"?"var(--green)":"var(--accent)",fontSize:13,fontWeight:600}}>
                    {o.status==="confirmed"?"✓ Paid":"⏳ Pending"}
                  </span></td>
                </tr>
              ))}
              {localOrders.length===0 && apiOrders.length===0 && (
                <tr><td colSpan={5} style={{color:"var(--muted)",textAlign:"center",padding:32}}>No orders yet</td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

// ─── MY PETS PAGE ─────────────────────────────────────────────────────────────
function MyPetsPage({ onBack, localOrders, user }) {
  const [preview,  setPreview]  = useState(null);
  const [uploaded, setUploaded] = useState(false);
  const [file,     setFile]     = useState(null);
  const fileRef = useRef(null);

  function handleFile(e){ const f=e.target.files[0]; if(!f) return; setFile(f); setPreview(URL.createObjectURL(f)); setUploaded(false); }
  function handleSubmit(){ if(!file) return; setUploaded(true); }

  return (
    <div className="page fade-up" style={{maxWidth:640}}>
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>
      <div className="page-title">My Bank Logs</div>
      <div className="page-sub">Bank Logs you have purchased</div>

      {/* Pets list or empty state */}
      {localOrders.length === 0 ? (
        <div style={{background:"var(--surface)",border:"1px solid var(--border)",borderRadius:"var(--radius)",padding:"48px 32px",textAlign:"center",marginBottom:32}}>
          <div style={{fontSize:52,marginBottom:16}}>🏦</div>
          <div style={{fontFamily:"Syne",fontWeight:700,fontSize:18,marginBottom:8}}>No bank logs yet</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.7,maxWidth:380,margin:"0 auto"}}>
            Once your Bitcoin payment is confirmed, your bank logs will appear here automatically. Confirmations typically take 10–30 minutes on the Bitcoin network.
          </div>
        </div>
      ) : (
        <div className="table-wrap" style={{marginBottom:32}}>
          <table>
            <thead><tr><th>Bank Logs</th><th>Description</th><th>Bank</th><th>Price (USD)</th><th>Date</th><th>Transaction Details</th></tr></thead>
            <tbody>
              {localOrders.map(o=>(
                <tr key={o.localId}>
                  <td><strong>{o.pet}</strong></td>
                  <td style={{color:"var(--muted)",fontSize:13,maxWidth:220}}>{o.description}</td>
                  <td style={{color:"var(--muted)"}}>{o.store}</td>
                  <td className="price-usd">{toUSD(o.price_btc)}</td>
                  <td className="date-cell">{o.date}</td>
                  <td>
                    <button className="dl-btn" onClick={()=>downloadReceipt(o,user)}>
                      <Download size={13}/> Download
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Support section */}
      <div style={{background:"rgba(247,147,26,.06)",border:"1px solid rgba(247,147,26,.2)",borderRadius:"var(--radius)",padding:"24px"}}>
        <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}>
          <Mail size={18} color="var(--accent)"/>
          <div style={{fontFamily:"Syne",fontWeight:700,fontSize:16}}>Bank Logs not showing up?</div>
        </div>
        <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.7,marginBottom:20}}>
          If you completed a payment and your bank logs have not appeared after 30 minutes, upload a screenshot of your payment confirmation and contact our support team. We will manually verify and activate your pet as soon as possible.
        </div>
        <div style={{display:"flex",alignItems:"center",gap:8,background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:8,padding:"10px 14px",marginBottom:20,fontSize:13}}>
          <Mail size={14} color="var(--muted)"/>
          <span style={{color:"var(--muted)"}}>Support:</span>
          <span style={{color:"var(--accent)",fontWeight:600}}>NexVault@bluemailx.com</span>
        </div>
        <div style={{fontSize:12,fontWeight:600,color:"var(--muted)",textTransform:"uppercase",letterSpacing:".5px",marginBottom:10}}>Upload Payment Screenshot</div>
        <div onClick={()=>fileRef.current?.click()}
          style={{border:"2px dashed var(--border)",borderRadius:10,padding:"24px",textAlign:"center",cursor:"pointer",transition:"border-color .2s",background:preview?"transparent":"var(--surface2)"}}
          onMouseEnter={e=>e.currentTarget.style.borderColor="var(--accent)"}
          onMouseLeave={e=>e.currentTarget.style.borderColor="var(--border)"}>
          {preview
            ? <img src={preview} alt="screenshot" style={{maxWidth:"100%",maxHeight:220,borderRadius:8,objectFit:"contain"}}/>
            : <><Upload size={28} color="var(--muted)" style={{marginBottom:8}}/><div style={{color:"var(--muted)",fontSize:13}}>Click to upload screenshot</div><div style={{color:"var(--muted)",fontSize:11,marginTop:4}}>PNG, JPG up to 10MB</div></>
          }
        </div>
        <input ref={fileRef} type="file" accept="image/*" style={{display:"none"}} onChange={handleFile}/>
        {preview && !uploaded && <button className="btn-primary" onClick={handleSubmit} style={{marginTop:16}}>Send to Support</button>}
        {uploaded && <div style={{display:"flex",alignItems:"center",gap:8,color:"var(--green)",fontWeight:600,fontSize:14,marginTop:12}}><Check size={16}/> Screenshot sent! Support will respond within 24 hours.</div>}
      </div>
    </div>
  );
}


// ─── TERMS PAGE ───────────────────────────────────────────────────────────────
function TermsPage({ onBack }) {
  return (
    <div className="page fade-up" style={{maxWidth:640}}>
      <button className="back-btn" onClick={onBack}><ArrowLeft size={16}/> Back</button>
      <div className="page-title">Terms &amp; Policies</div>
      <div className="page-sub">Last updated May 2025</div>

      {[
        ["Payments", "All prices are displayed in USD and settled exclusively in Bitcoin (BTC) at the current exchange rate. Payments are final once confirmed on-chain."],
        ["Privacy", "User data is stored securely and never sold to third parties. On-chain transaction data is publicly visible by nature of Bitcoin."],
      ].map(([title, body]) => (
        <div key={title} style={{marginBottom:24}}>
          <div style={{fontFamily:"Syne",fontWeight:700,marginBottom:6}}>{title}</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.7}}>{body}</div>
        </div>
      ))}

      {/* ── Payment Instructions section from image 1 ── */}
      <div style={{marginTop:16,paddingTop:24,borderTop:"1px solid var(--border)"}}>
        <div style={{fontFamily:"Syne",fontWeight:700,fontSize:18,marginBottom:16}}>Payment Instructions</div>
        <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.8,marginBottom:16}}>
          To complete your purchase securely, please follow these simple payment instructions.
        </div>

        <div style={{marginBottom:16}}>
          <div style={{fontFamily:"Syne",fontWeight:700,marginBottom:8}}>Initiating a BTC Transfer</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.8,marginBottom:10}}>
            Initiate a BTC transfer to the address displayed on your payment screen. Once you complete the transfer, you will be required to provide a payment screenshot.
          </div>
          <div style={{background:"var(--surface2)",border:"1px solid var(--border)",borderRadius:8,padding:"10px 14px",fontSize:13,color:"var(--muted)",fontFamily:"monospace",wordBreak:"break-all"}}>
            Example: bc1qy3vpnmmq9wml4gwag90vqj84xw35uxgahuwglh
          </div>
        </div>

        <div style={{marginBottom:16}}>
          <div style={{fontFamily:"Syne",fontWeight:700,marginBottom:8}}>Accepted Screenshot Formats</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.8}}>
            We accept image files in JPEG, PNG, and GIF formats. Ensure your proof of payment is clear and legible to expedite the verification process.
          </div>
        </div>

        <div style={{marginBottom:16}}>
          <div style={{fontFamily:"Syne",fontWeight:700,marginBottom:8}}>Confirmation Timeline</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.8}}>
            BTC transactions typically take a short time to confirm. You can expect to receive a confirmation within the next hour. Once confirmed, you'll gain access to your purchased log details.
          </div>
        </div>

        <div style={{marginBottom:16}}>
          <div style={{fontFamily:"Syne",fontWeight:700,marginBottom:8}}>Security</div>
          <div style={{color:"var(--muted)",fontSize:14,lineHeight:1.8}}>
            Your security is our top priority. All transactions are encrypted using industry-standard protocols. We employ secure channels to protect your payment information. If you have any security-related concerns, feel free to reach out to our dedicated support team.
          </div>
        </div>

        {/* BTC-only warning — same red notice from image 2 */}
        <div style={{background:"rgba(239,68,68,.08)",border:"1px solid rgba(239,68,68,.3)",borderRadius:10,padding:"16px 20px",marginBottom:16}}>
          <div style={{fontFamily:"Syne",fontWeight:700,fontSize:14,marginBottom:4}}>Send Only BTC</div>
          <div style={{fontSize:13,color:"var(--muted)",marginBottom:6}}>Send only BTC to the payment address.</div>
          <div style={{fontSize:13,fontWeight:600,color:"var(--red)"}}>Sending coins or tokens other than BTC will result in the loss of funds.</div>
        </div>

        <div style={{background:"rgba(247,147,26,.06)",border:"1px solid rgba(247,147,26,.2)",borderRadius:10,padding:"16px 20px"}}>
          <div style={{fontFamily:"Syne",fontWeight:700,fontSize:14,marginBottom:4}}>Need Assistance?</div>
          <div style={{color:"var(--muted)",fontSize:13,lineHeight:1.7}}>
            Our customer support team is here to help. For quick and efficient assistance, please contact us at{" "}
            <span style={{color:"var(--accent)",fontWeight:600}}>NexVault@bluemailx.com</span>.
          </div>
        </div>
      </div>
    </div>
  );
}

// ─── HOME PAGE ────────────────────────────────────────────────────────────────
function HomePage({ stores, storesLoading, onSelectBreed }) {
  const [openStores, setOpenStores] = useState({});

   return (
      <div className="page fade-up">
        <div className="page-title">Market Activity</div>
        <div className="page-sub">Recent transactions</div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Bank Logs</th><th>Buyer</th><th>Price (USD)</th><th>Status</th></tr></thead>
            <tbody>
              {MOCK_TRANSACTIONS.map(t=>(
                <tr key={t.id}>
                  <td><strong>{t.pet_type}</strong></td>
                  <td><span className="user-chip">🔒 {t.user_name}</span></td>
                  <td><div className="price-usd">{toUSD(t.amount_btc)}</div></td>
                  <td><span style={{background:"#FF0000",color:"#000",fontFamily:"'Syne',sans-serif",fontWeight:700,fontSize:12,padding:"5px 14px",borderRadius:8,display:"inline-block"}}>Sold</span></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
      </div>
    );

}

// ─── LANDING PAGE ─────────────────────────────────────────────────────────────
function LandingPage({ onAuth, authError }) {
  const [tab,      setTab]      = useState("login");
  const [email,    setEmail]    = useState("");
  const [password, setPassword] = useState("");
  const [name,     setName]     = useState("");
  const [error,    setError]    = useState("");
  const [loading,  setLoading]  = useState(false);

  async function handle() {
    setError("");
    if (!email || !password) { setError("Please fill in all fields."); return; }
    if (tab === "signup" && !name) { setError("Please enter your name."); return; }
    setLoading(true);
    try { await onAuth(tab, email, password, name); }
    catch(e) { setError(e.message || "Auth failed"); }
    finally { setLoading(false); }
  }

  return (
    <div className="landing">
      <img src="/img 111.jpeg" className="landing-bg" alt=""/>
      <div className="landing-overlay"/>

      <div className="landing-card fade-up">

        {/* LEFT PANEL */}
        <div className="panel-left">
          <div className="brand-row">
            <div className="brand-icon">🏦</div>
            <div className="brand-name">NexVault</div>
          </div>
          <div className="tagline">
            <div className="tagline-headline">
              The future of<br/>digital trading,<br/><span>on-chain.</span>
            </div>
            <div className="tagline-body">
              Buy and sell bank logs securely with Bitcoin. Exclusive listings,
              full order tracking — all in one place.
            </div>
            <div className="trust-row">
              <div className="trust-item"><span className="trust-dot"/><span>On-chain Bitcoin payments</span></div>
              <div className="trust-item"><span className="trust-dot"/><span>JWT-secured sessions</span></div>
              <div className="trust-item"><span className="trust-dot"/><span>End-to-end encrypted transfers</span></div>
            </div>
          </div>
        </div>

        {/* RIGHT PANEL */}
        <div className="panel-right">
          <div className="panel-title">
            {tab === "login" ? "Welcome back" : "Create account"}
          </div>
          <div className="panel-sub">
            {tab === "login"
              ? "Sign in to your account to continue"
              : "Join NexVault — it takes 30 seconds"}
          </div>

          <div className="auth-tabs">
            <button
              className={`auth-tab ${tab === "login" ? "active" : ""}`}
              onClick={() => setTab("login")}
            >Login</button>
            <button
              className={`auth-tab ${tab === "signup" ? "active" : ""}`}
              onClick={() => setTab("signup")}
            >Sign Up</button>
          </div>

          {tab === "signup" && (
            <div className="form-group">
              <label className="form-label">Full Name</label>
              <input
                className="form-input"
                placeholder="Ron Dennis"
                value={name}
                onChange={e => setName(e.target.value)}
              />
            </div>
          )}

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className="form-input"
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-input"
              type="password"
              placeholder="••••••••"
              value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === "Enter" && handle()}
            />
          </div>

          {(error || authError) && (
            <div className="error-msg">{error || authError}</div>
          )}

          <button className="btn-primary" onClick={handle} disabled={loading}>
            {loading ? "Please wait…" : tab === "login" ? "Login" : "Create Account"}
          </button>

          <div className="divider-line"><span>SECURED BY</span></div>
          <div className="btc-badge-row">
            <span className="btc-dot"/>
            <span>Bitcoin Network · Lightning Accepted</span>
          </div>
        </div>

      </div>
    </div>
  );
}
// ─── ROOT APP ─────────────────────────────────────────────────────────────────
export default function App() {
  const { user, token, login, signup, logout } = useAuth();
  const [sidebarOpen,    setSidebarOpen]    = useState(false);
  const [screen,         setScreen]         = useState("home");
  const [selectedStore,  setSelectedStore]  = useState(null);
  const [selectedBreed,  setSelectedBreed]  = useState(null);
  const [selectedAnimal, setSelectedAnimal] = useState(null);
  const [authError,      setAuthError]      = useState("");
  const [stores,         setStores]         = useState([]);
  const [storesLoading,  setStoresLoading]  = useState(true);
   const [localOrders, setLocalOrders] = useState(() => {
  try { return JSON.parse(localStorage.getItem("pm_orders")) || []; } catch { return []; }
});
const [btcRate, setBtcRate] = useState(73123);

useEffect(() => {
  const fetchRate = () =>
    fetch(`${API}/rate`)
      .then(r => r.json())
      .then(d => { if (d.usd) setBtcRate(d.usd); })
      .catch(() => {});
  fetchRate();
  const iv = setInterval(fetchRate, 60000);
  return () => clearInterval(iv);
}, []);


  useEffect(()=>{
    const el = document.createElement("style");
    el.textContent = css;
    document.head.appendChild(el);
    return ()=>el.remove();
  },[]);

  useEffect(()=>{
  if(!user) return;
  let attempts = 0;
  function fetchStores(){
    apiFetch("/stores")
      .then(d=>{ setStores(d.stores); setStoresLoading(false); })
      .catch(e=>{
        attempts++;
        if(attempts < 5){ setTimeout(fetchStores, 2000); }
        else{ console.error("Stores failed:",e); setStoresLoading(false); }
      });
  }
  fetchStores();
},[user]);

  async function handleAuth(tab,email,password,name){
    setAuthError("");
    try {
      if (tab==="login") await login(email,password);
      else await signup(email,password,name);
    } catch(e){ setAuthError(e.message||"Auth failed"); throw e; }
  }

  if (!user) return <div className="app"><LandingPage onAuth={handleAuth} authError={authError}/></div>;

  function handlePaid(order){
  setLocalOrders(p => {
    const updated = [order, ...p];
    localStorage.setItem("pm_orders", JSON.stringify(updated));
    return updated;
  });
}

  return (
    <div className="app main-layout">
      <div className="topbar">
        <button onClick={()=>setSidebarOpen(true)} style={{background:"none",border:"none",color:"var(--text)",cursor:"pointer",display:"flex",alignItems:"center",padding:4}}>
          <Menu size={22}/>
        </button>
        <span className="topbar-logo">NexVault</span>
        <div className="topbar-right">
          <div className="btc-badge"><Bitcoin size={13}/> Secured Payments</div>
        </div>
      </div>

            <Sidebar open={sidebarOpen} onClose={()=>setSidebarOpen(false)} user={user} onLogout={logout}
        onNav={p=>setScreen(p)} stores={stores} localOrders={localOrders}
        onSelectStore={store=>{ setSelectedStore(store); setScreen("breed"); }}
        onSelectAnimal={(animal,store)=>{ setSelectedAnimal(animal); setSelectedStore(store); setScreen("animal"); }}/>

      {screen==="home"    && <HomePage stores={stores} storesLoading={storesLoading} onSelectBreed={store=>{setSelectedStore(store);setScreen("breed");}}/>}
      {screen==="breed"   && selectedStore && <BreedScreen store={selectedStore} onBack={()=>setScreen("home")} onBuy={breed=>{setSelectedBreed(breed);setScreen("payment");}}/>}
      {screen==="animal" && selectedAnimal && selectedStore && <AnimalScreen animal={selectedAnimal} store={selectedStore} onBack={()=>setScreen("home")} onBuy={a=>{setSelectedBreed(a);setScreen("payment");}}/>}
      {screen==="payment" && selectedBreed && selectedStore && <BTCPayment item={selectedBreed} store={selectedStore} token={token} user={user} onBack={()=>setScreen("animal")} onPaid={handlePaid} onGoToPets={()=>setScreen("mypets")}/>}
      {screen==="account" && <AccountPage user={user} onBack={()=>setScreen("home")}/>}
      {screen==="history" && <HistoryPage token={token} ocalOrders={localOrders} onBack={()=>setScreen("home")}/>}
      {screen==="terms"   && <TermsPage onBack={()=>setScreen("home")}/>}
      {screen==="mypets"  && <MyPetsPage onBack={()=>setScreen("home")} localOrders={[]} user={user}/>}
    </div>
  );
}